// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:28:30.882Z
// Property: Via6 (ID: 6767906449166934)
// Collections: 101 amenities, 32 floorplans (live), 25 photos, 82 POIs, 4 reviews, 13 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449166934",
  "property_external_id": "2263974",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/via-6/5XqWDb/",
  "property_apartments_url": "https://www.apartments.com/via6-seattle-wa/kcfv0lc/",
  "property_google_business_url": "https://www.google.com/maps/place/Via+6/data=!4m2!3m1!1s0x0:0x1359e040dcde815b?sa=X&ved=2ahUKEwjrm8HR_LmSAxUcKEQIHb_RK4IQ_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "44458628388",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "via6",
  "property_name": "Via6",
  "property_website_url": "https://www.via6living.com/",
  "property_domain": "https://www.via6living.com/",
  "property_address": "2121 6th Avenue",
  "property_full_address": "2121 6th Ave, Seattle, WA 98121",
  "property_address_1": "2121 6th Avenue",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": "98121",
  "property_address_zip": "98121",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Downtown Seattle",
  "property_address_latitude": "47.6153337",
  "property_address_longitude": "-122.3405084",
  "property_email": "via6@weidner.com",
  "property_phone": "(206) 339-6691",
  "property_call_tracking_phone": "206-339-6691",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Welcome to Via6 in Seattle, WA. Explore spacious 1 &amp; 2-bedroom apartments with walk-in closets, private balconies, a fitness center, dog park, and clubhouse.</p>",
  "property_long_description": "<p>Via6 Apartments redefines what it means to work, live, and play in Seattle. Our pet-friendly community is located in the desirable South Lake Union neighborhood. It offers an unparalleled lifestyle that seamlessly integrates retail, services, and community allure into a one-of-a-kind living experience. Located on Amazon HQ’s doorstep, you’ll live at the crossroads of one of the most interconnected talent centers in the country, with Meta, Google, Apple, Expedia, and Fred Hutch steps away. Living here puts you close to the best Seattle has to offer, with light rail stops that reach the SeaTac Airport, Space Needle, and Climate Pledge Arena within minutes. Whether your priority is mobility, convenience, or comfort, Via6 offers a lifestyle that is truly second to none.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-8c25-71d0-bc6d-d8f5af5206c3.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop patio with seating and city skyline",
    "public_id": "019d01ad-8c25-71d0-bc6d-d8f5af5206c3",
    "storage_key": "property/6767906449166934/019d01ad-8c25-71d0-bc6d-d8f5af5206c3.webp",
    "width": 800,
    "height": 500
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166934/01a1640e-cdbe-71d4-aa36-3e89f19509c1.mp4",
  "property_featured_video_media": {
    "public_id": "01a1640e-cdbe-71d4-aa36-3e89f19509c1",
    "storage_key": "property/6767906449166934/01a1640e-cdbe-71d4-aa36-3e89f19509c1.mp4",
    "thumbnail_key": "property/6767906449166934/01a1640e-cdbe-71d4-aa36-3e89f19509c1_thumb.webp",
    "size_bytes": 23204594,
    "classification": "Community",
    "title": "Explore Our Vibrant Community Amenities and Living Spaces",
    "description": "Discover the best of apartment living with our state-of-the-art gym, inviting social spaces, and modern, comfortable interiors. Experience a lifestyle designed for you."
  },
  "property_total_units": "654",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": "100",
  "property_transit_score": "100",
  "property_business_hours_list": null,
  "property_current_occupancy": "96.02446483180428",
  "property_admin_fee": null,
  "property_application_fee": "10",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://via6living.securecafe.com/onlineleasing/via-60/floorplans.aspx",
  "property_resident_portal_url": "https://via6living.securecafenet.com/residentservices/via-60/userlogin",
  "property_apply_now_url": "https://via6living.securecafe.com/onlineleasing/via-60/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bad-5977-70c4-9f45-80781e304520.webp",
  "property_primary_logo_media": {
    "alt_text": "Via 6 logo with white text and a blue accent.",
    "public_id": "019e3bad-5977-70c4-9f45-80781e304520",
    "storage_key": "property/6767906449166934/019e3bad-5977-70c4-9f45-80781e304520.webp",
    "width": 1411,
    "height": 655
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
  "property_secondary_logo_media": {
    "alt_text": "Via 6 logo",
    "public_id": "019e3bcd-064c-7249-bee9-2e7a2e0b3944",
    "storage_key": "property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
    "width": 480,
    "height": 480
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
  "property_icon_media": {
    "alt_text": "Via 6 logo",
    "public_id": "019e3bcd-064c-7249-bee9-2e7a2e0b3944",
    "storage_key": "property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
    "width": 480,
    "height": 480
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
  "property_fav_icon_media": {
    "alt_text": "Via 6 logo",
    "public_id": "019e3bcd-064c-7249-bee9-2e7a2e0b3944",
    "storage_key": "property/6767906449166934/019e3bcd-064c-7249-bee9-2e7a2e0b3944.webp",
    "width": 480,
    "height": 480
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bad-b87b-77d0-abb5-07c337e0e555.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e3bad-b87b-77d0-abb5-07c337e0e555",
    "storage_key": "property/6767906449166934/019e3bad-b87b-77d0-abb5-07c337e0e555.webp",
    "width": 1280,
    "height": 594
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bad-ae12-732e-b4f4-2ba981f7c1cf.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e3bad-ae12-732e-b4f4-2ba981f7c1cf",
    "storage_key": "property/6767906449166934/019e3bad-ae12-732e-b4f4-2ba981f7c1cf.webp",
    "width": 1280,
    "height": 594
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#162131",
  "property_secondary_color": "#1aace2",
  "property_font_color": "#ffffff",
  "property_color_4": "#000000",
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "465 - 1029",
  "property_sqft_min": "465",
  "property_sqft_max": "1029",
  "property_price_range": "16.6 - 3840.35",
  "property_price_min": "2102",
  "property_price_max": "3841",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/Via6Seattle/",
  "property_instagram_url": "https://www.instagram.com/via6seattle/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_QAalksVkFQRW4He3EDgWRM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/discover/via6-seattle-apartment",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Via6",
  "property_home_romance_title": "Embrace the Perfect Haven for Your New Beginning",
  "property_home_amenities_blurb": "Welcome to Via6, a vibrant Seattle community that seamlessly blends style and comfort. With thoughtfully designed one and two-bedroom floor plans, enjoy modern amenities like a fitness center, dog park, and relaxing balconies. Experience life elevated at Via6, where community and convenience come together.",
  "property_home_floorplans_blurb": "At Via6 in vibrant Seattle, WA, your ideal living space awaits. Choose from our thoughtfully designed one and two-bedroom floor plans that blend style and comfort. Start your journey to a perfect home—browse our available apartment options today and elevate your urban lifestyle at Via6!",
  "property_home_gallery_blurb": "At Via6 in Seattle, WA, your ideal lifestyle awaits. Choose from spacious one and two-bedroom floor plans, each enhanced with walk-in closets, air conditioning, and modern kitchens. Unwind in our clubhouse or take Fido for a romp in the dog park. Picture yourself living here, where comfort meets convenience!",
  "property_home_neighborhood_blurb": "At Via6, your urban sanctuary blends modern living with vibrant Seattle life. Nestled in the heart of South Lake Union, enjoy proximity to cultural destinations like the Museum of Pop Culture, Seattle Art Museum, and the stunning Olympic Sculpture Park. Dive into the local scene and uncover cherished hidden gems nearby!",
  "property_home_reviews_blurb": "At Via6, you’ll find a vibrant Seattle retreat where friendly staff and incredible amenities unite. \"It's an amazing apartment building...close to everything,\" shared a resident, perfectly capturing the essence of our prime location. Enjoy breathtaking views, lively community events, and a lifestyle that balances comfort with urban excitement.",
  "property_neighborhood_blurb": "At Via6 in the heart of Seattle, vibrant city life meets serene living. Nestled among cultural gems like the Museum of Pop Culture and the Seattle Art Museum, you're never far from adventure. Journey through green spaces and educational hubs, and unveil a lifestyle enriched by our dynamic neighborhood.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the vibrant lifestyle at Via6 in Seattle, WA, where modern living meets comfort. Our one and two-bedroom apartments feature spacious layouts, walk-in closets, and stylish balconies. Enjoy impressive amenities like a state-of-the-art fitness center, a relaxing clubhouse, and a dog park, all designed for your dynamic lifestyle.",
  "property_applynow_blurb": "Elevate your lifestyle at Via6 in Seattle, WA, where comfort meets convenience. Choose from spacious one or two-bedroom floor plans, featuring modern amenities like a state-of-the-art fitness center, inviting clubhouse, and a relaxing dog park. Embrace your new home—lease online today!",
  "property_contactus_blurb": "At Via6 in vibrant Seattle, WA, you’ll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Ready to take the next step? Our leasing team is here to answer your questions and help you envision your new home. Reach out today!",
  "property_faqs_blurb": "At Via6 in vibrant Seattle, WA, our meticulously designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Curious about our community? Visit our FAQs page for insights and answers to enhance your living experience at Via6. Your ideal apartment lifestyle awaits!",
  "property_floorplans_blurb": "At Via6 in vibrant Seattle, WA, our thoughtfully designed floor plans cater to your lifestyle. Choose from stylish one-bedroom or spacious two-bedroom layouts, each imbued with modern comforts. Browse our available apartment homes to find the perfect fit that reflects your unique vision of home.",
  "property_gallery_blurb": "At Via6 in vibrant Seattle, WA, your dream lifestyle awaits! Our thoughtfully designed one and two-bedroom apartments feature modern amenities like walk-in closets, in-unit washers and dryers, and private balconies. With a fitness center, dog park, and inviting clubhouse, imagine the possibilities. Picture yourself living here!",
  "property_interactivemap_blurb": "At Via6 in vibrant Seattle, WA, choose from spacious one- and two-bedroom floor plans designed for both comfort and style. Indulge in exceptional amenities, from a modern fitness center to a welcoming dog park. Use our interactive community map to find your perfect apartment and elevate your lifestyle today!",
  "property_pets_blurb": "At Via6 in vibrant Seattle, your furry companions are part of the family! With a welcoming atmosphere and beautiful amenities, our community fosters a pet-friendly lifestyle. Enjoy life with your beloved dog or cat, just keep in mind our breed restrictions and a small monthly pet fee. ",
  "property_referafriend_blurb": "At Via6 in Seattle, WA, your ideal living space awaits—from stylish one-bedroom retreats to spacious two-bedroom havens. Invite your friends to join our vibrant community; great friends make great neighbors! Share the joy of apartment life at Via6 and enhance your Seattle experience together.",
  "property_residentaccess_blurb": "Welcome to Via6 in vibrant Seattle, WA, where your comfort awaits! Our diverse floor plans, featuring stylish one and two-bedroom apartments, cater to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy seamless living. Experience community like never before at Via6!",
  "property_reviews_blurb": "At Via6 in Seattle, residents rave about the vibrant community and exceptional location near the Amazon Spheres. With breathtaking views of downtown, a large fitness center, and inviting rooftop lounges, our apartments blend comfort with convenience. “The staff is friendly, accommodating, and extremely helpful,” making every day feel like home at Via6.",
  "property_created_at": "1763658473611",
  "property_scheduletour_blurb": "At Via6 in Seattle, WA, we offer thoughtfully designed one and two-bedroom floor plans that perfectly blend comfort and style. Ready to envision your new home? Schedule a tour today and discover why our residents rave about their vibrant community experience! Their stories await—don't miss out!",
  "property_thankyou_blurb": "Thank you for reaching out to Via6, your future home in the heart of Seattle! With spacious one and two-bedroom floor plans, we offer a vibrant lifestyle designed just for you. Our team will connect soon to help you take the next step towards living in this remarkable community!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle of Via6 in Seattle, WA, where modern one and two-bedroom apartments await you. Immerse yourself in our welcoming community—take a virtual tour today to envision your new home filled with comfort and contemporary flair! Your perfect apartment is just a click away.",
  "property_copyright": "2026 All Rights Reserved. Via6",
  "property_seo_title_home": "Via6 | Luxury Apartments in Seattle, WA",
  "property_seo_description_home": "Welcome to Via6 in Seattle, WA. Explore spacious 1 &; 2-bedroom apartments with walk-in closets, a fitness center, dog park, and clubhouse",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Via6 in Seattle, WA! Choose from stylish one or two-bedroom floor plans designed for modern living. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Via6 in Seattle with modern amenities, a fitness center, dog park, and stylish apartments. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Picture life at Via6 in Seattle! Enjoy modern one & two-bedroom apartments with top-tier amenities: fitness center, dog park, and stunning views await!",
  "property_seo_title_virtualtours": "Virtual Tours | Via6 Apartments",
  "property_seo_description_virtualtours": "Step inside Via6 in Seattle, WA! Enjoy one and two-bedroom floor plans—take a virtual tour today and envision your new apartment home.",
  "property_seo_title_interactivemap": "Interactive Map | Via6 Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Via6 in Seattle, WA! Explore one and two-bedroom floor plans and great amenities with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Experience vibrant Seattle living at Via6! Uncover local gems and discover the best spots around our community. Your new adventure starts here!",
  "property_seo_title_contact": "Contact Us | Via6",
  "property_seo_description_contact": "Connect with our leasing team for any inquiries about our stylish one and two-bedroom apartments in Seattle at Via6. Your urban oasis awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Get answers to your burning questions about Via6 in Seattle! Learn about our stylish floor plans, top-notch amenities, and living at its finest.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Uncover why residents love Via6 in Seattle! From spacious floor plans to top-notch amenities, read their stories and experience the perfect urban lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Elevate your lifestyle at Via6 in Seattle! Enjoy spacious apartments with top amenities like a fitness center, dog park, and concierge. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Via6",
  "property_seo_description_residentaccess": "Log in to Via6's resident portal for hassle-free rent payments, quick maintenance requests, and exclusive community updates. Your Seattle living made simple!",
  "property_seo_title_referafriend": "Refer A Friend | Via6",
  "property_seo_description_referafriend": "Refer a friend to Via6 in Seattle and create a vibrant community together! Great friends make the best neighbors. Join us in making memories today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Via6",
  "property_seo_description_scheduletour": "Experience the vibrant life at Via6 in Seattle! Schedule a tour today and envision your perfect home amidst stunning amenities and charming surroundings.",
  "property_seo_title_privacy": "Privacy Policy | Via6",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Via6 in Seattle. Learn how we protect your data and uphold your privacy. Read our policy for full details!",
  "property_seo_title_accessibility": "Website Accessibility | Via6",
  "property_seo_description_accessibility": "At Via6 in Seattle, we prioritize digital inclusion. Our Accessibility Statement reflects our commitment to a welcoming community for all. Join us!",
  "property_seo_title_sitemap": "Sitemap | Via6",
  "property_seo_description_sitemap": "Navigate the vibrant lifestyle of Via6 in Seattle, WA. Our sitemap guides you through amenities, floor plans, and community offerings for your perfect home!",
  "property_seo_title_thankyou": "Thank You | Via6",
  "property_seo_description_thankyou": "Thank you for reaching out to Via6 in Seattle! Your inquiry is important to us, and our team will be in touch soon to assist you in finding your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119460510",
  "amenities": [
    {
      "id": "ec_d7477d6c0b4cb7fa81ac7c77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083062",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_774dd9802febb6e74da49b0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083051",
      "title": "Air conditioning*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_237c56be54a99aab70dcd504",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083055",
      "title": "In-home washer/dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c99f92afcbd5c3fa9f00cb0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083049",
      "title": "Gourmet kitchens w/energy-efficient appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0acf99e027517c08d091a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083059",
      "title": "Mello Fello's Bike Shop",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_147a17c449c9cf08cec7be8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083050",
      "title": "Views of the City and Puget Sound",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be7b613e2d65e94a0cddbcea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083060",
      "title": "Walk to Work! In the heart of Downtown and South Lake Union",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11cd0f51d6cfcc628d4e36cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083061",
      "title": "24-hour concierge services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3c8f5c79ee642810ef5dffa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083052",
      "title": "Walk-in closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_137596825e34b2c1fb01f152",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083063",
      "title": "Pet spa and relief area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36c6b9bff682fa8c24809e58",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083053",
      "title": "Stone countertops in kitchens and bath spaces",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09b2d35a6b7c0d6cef7c6e84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083054",
      "title": "Ceramic stovetop ranges",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec34cefef9e1d5c2390e704a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083064",
      "title": "Controlled Access Package Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dea9622814b335ac469f675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083065",
      "title": "Victor Tavern by Ethan Stowell",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a837d9405552a6d17daffb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083066",
      "title": "Chef’s Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efef3ff8ee2b54ac969f8116",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083056",
      "title": "Gigabit Wi-fi Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aec898bff85d21c4c37f28df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083057",
      "title": "Penthouse level homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83976c714dcfa1aff4c32a4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083068",
      "title": "Rubinstein Bagels",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92507ba733846a83bf320d78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083069",
      "title": "Outside deck with grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c523d9c03e8f5f77fc572a45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083058",
      "title": "Private balconies*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9c58b7016c8715503f3aaf7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781984",
      "title": "Accessible",
      "amount": "false",
      "description": "Accessible",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1c5eb1c19f0899aea164ef9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083072",
      "title": "Bike Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f22cae1f74ea026d88b8299",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781986",
      "title": "Backsplash",
      "amount": "false",
      "description": "Backsplash",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f34fabf5a94420695c5d80b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126083073",
      "title": "Onsite retail includes Rudy’s Barbershop",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c5f36fd108ef56fb7354237",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "128984219",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7630149fa93a88a5c81f9119",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781989",
      "title": "Corner Unit",
      "amount": "false",
      "description": "Corner Unit",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_555a51a49c6c8815580bc366",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781991",
      "title": "Extra Storage",
      "amount": "false",
      "description": "Extra Storage",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a823751fe545602ea970f558",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781992",
      "title": "Floor Level 11",
      "amount": "false",
      "description": "Floor Level 11",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15ed6b23ef3e325b176aed55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781994",
      "title": "Floor Level 14",
      "amount": "false",
      "description": "Floor Level 14",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4fca14ae79a90495118b303",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781995",
      "title": "Floor Level 17",
      "amount": "false",
      "description": "Floor Level 17",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e5a356b068c47e9d931943e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126781998",
      "title": "Floor Level 2",
      "amount": "false",
      "description": "Floor Level 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_344209f7c0fd48630074f12b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782000",
      "title": "Floor Level 20",
      "amount": "false",
      "description": "Floor Level 20",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a2e8899970671a6da69b962",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782001",
      "title": "Floor Level 23",
      "amount": "false",
      "description": "Floor Level 23",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df0e49eb75de5be0ac029143",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782003",
      "title": "Floor Level 5",
      "amount": "false",
      "description": "Floor Level 5",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca8fc9a0724d1919dffd40e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782004",
      "title": "Floor Level 8",
      "amount": "false",
      "description": "Floor Level 8",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76c5f9223380e575828309f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782005",
      "title": "Hardwood Floor",
      "amount": "false",
      "description": "Hardwood Floor",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9c3dc1127c921bdac07d9d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782006",
      "title": "Large Entry",
      "amount": "false",
      "description": "Large Entry",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f827c574364abd6329606aed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782007",
      "title": "Large Living Room",
      "amount": "false",
      "description": "Large Living Room",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85098063c7753fcae0125cf1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782008",
      "title": "No Air Conditioner",
      "amount": "false",
      "description": "No Air Conditioner",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1e27dfebb56a71bd82a1bb5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782009",
      "title": "Pantry",
      "amount": "false",
      "description": "Pantry",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec50800050a30365630fc4da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782010",
      "title": "Penthouse 1",
      "amount": "false",
      "description": "Penthouse 1",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e5f32f3bf44e100e63399ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782012",
      "title": "Penthouse 2",
      "amount": "false",
      "description": "Penthouse 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f073b94c97a0c0a98e7ec66b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782016",
      "title": "Penthouse 3",
      "amount": "false",
      "description": "Penthouse 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6952e9e5e37c2fb05deffd77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782018",
      "title": "Renovated 1",
      "amount": "false",
      "description": "Renovated 1",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82fa49607a0a32b16e049b3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782103",
      "title": "Renovated 2",
      "amount": "false",
      "description": "Renovated 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fb71cc4b03f8055d417e170",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782104",
      "title": "Renovated 3",
      "amount": "false",
      "description": "Renovated 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e533c6e8826a9dc1886b0038",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782105",
      "title": "Renovated 4",
      "amount": "false",
      "description": "Renovated 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a9058a2a05145f375a3eca5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782106",
      "title": "Terrace 1",
      "amount": "false",
      "description": "Terrace 1",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4e552763c5f5616f5c11be0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782107",
      "title": "Terrace 2",
      "amount": "false",
      "description": "Terrace 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d21b8380f319f0e1bb2b65e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782108",
      "title": "View 10",
      "amount": "false",
      "description": "View 10",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e088a0e44596f27dea19635",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782110",
      "title": "View 3",
      "amount": "false",
      "description": "View 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba6acedb89c2f9b1877b17e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782111",
      "title": "View 4",
      "amount": "false",
      "description": "View 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a54f7fefca39299e07baeb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782114",
      "title": "View 5",
      "amount": "false",
      "description": "View 5",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbdfe47f8fa746efa21a1d42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782116",
      "title": "View 6",
      "amount": "false",
      "description": "View 6",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4c7942b3a989050f5cb8ec8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782118",
      "title": "View 7",
      "amount": "false",
      "description": "View 7",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1de3416b7d4150499d91eb91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782119",
      "title": "View 8",
      "amount": "false",
      "description": "View 8",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d0d87061df0bb7bac4036f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "126782121",
      "title": "View 9",
      "amount": "false",
      "description": "View 9",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e7446c047ab272e27ee0db6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826910",
      "title": "Additional 7 Square Feet",
      "amount": "false",
      "description": "Additional 7 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d0d91854e390291dec12bde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826911",
      "title": "Additional 13 Square Feet",
      "amount": "false",
      "description": "Additional 13 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f17a7533313829c877cc610",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826912",
      "title": "Additional 16 Square Feet",
      "amount": "false",
      "description": "Additional 16 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8908e463dcc398a7cc83671",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826913",
      "title": "Additional 17 Square Feet",
      "amount": "false",
      "description": "Additional 17 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_204689e00392504af3010aab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826914",
      "title": "Additional 18 Square Feet",
      "amount": "false",
      "description": "Additional 18 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9684aa56e72ab4df3d7200d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826915",
      "title": "Additional 19 Square Feet",
      "amount": "false",
      "description": "Additional 19 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70d61f7e732f12f1671eda62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826917",
      "title": "Additional 24 Square Feet",
      "amount": "false",
      "description": "Additional 24 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0c50ead34ad61f331d7809d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826918",
      "title": "Additional 28 Square Feet",
      "amount": "false",
      "description": "Additional 28 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ac0a7144bb0c5c49a29dc40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826919",
      "title": "Additional 29 Square Feet",
      "amount": "false",
      "description": "Additional 29 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6c0f94679034e5791f86760",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826921",
      "title": "Additional 31 Square Feet",
      "amount": "false",
      "description": "Additional 31 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fb3d7d03daead702057c09f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826922",
      "title": "Additional 35 Square Feet",
      "amount": "false",
      "description": "Additional 35 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82d66c813a1b8ac0ca3c402c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826923",
      "title": "Additional 37 Square Feet",
      "amount": "false",
      "description": "Additional 37 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc726f3778f880415b78bdd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826924",
      "title": "Additional 43 Square Feet",
      "amount": "false",
      "description": "Additional 43 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ea7b158c03841a4ef849ee7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826925",
      "title": "Additional 47 Square Feet",
      "amount": "false",
      "description": "Additional 47 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a7f13fd09bf826e5376fce5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826945",
      "title": "Additional 59 Square Feet",
      "amount": "false",
      "description": "Additional 59 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7a223c701ead049bf95c39d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826946",
      "title": "Additional 63 Square Feet",
      "amount": "false",
      "description": "Additional 63 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ee8e9f56a9cf10f648b127c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826947",
      "title": "Additional 65 Square Feet",
      "amount": "false",
      "description": "Additional 65 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00cdd3a5d454cce034a69054",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826991",
      "title": "Additional 86 Square Feet",
      "amount": "false",
      "description": "Additional 86 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f90ff515b933c5d044c80d4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127826992",
      "title": "Additional 105 Square Feet",
      "amount": "false",
      "description": "Additional 105 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afd62d659c9e0fabe1a54848",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827014",
      "title": "Additional 109 Square Feet",
      "amount": "false",
      "description": "Additional 109 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d80f78faf809ac65f7d2a491",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827015",
      "title": "Additional 145 Square Feet",
      "amount": "false",
      "description": "Additional 145 Square Feet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bceff80b35f1800a72c38d22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827020",
      "title": "Floor Level 3",
      "amount": "false",
      "description": "Floor Level 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cff69d528b292a26d860fa6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827021",
      "title": "Floor Level 4",
      "amount": "false",
      "description": "Floor Level 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51dc444d1bd7fdb712a64486",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827022",
      "title": "Floor Level 6",
      "amount": "false",
      "description": "Floor Level 6",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a564cac0256a667de1366b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827023",
      "title": "Floor Level 7",
      "amount": "false",
      "description": "Floor Level 7",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca34e4ad137f554cdbb87f0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827024",
      "title": "Floor Level 9",
      "amount": "false",
      "description": "Floor Level 9",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a735265fbe01b79cca2cdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827025",
      "title": "Floor Level 10",
      "amount": "false",
      "description": "Floor Level 10",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f42f4f933c2ef76de714a44f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827026",
      "title": "Floor Level 12",
      "amount": "false",
      "description": "Floor Level 12",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53e1e8186066cede8178bf65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827027",
      "title": "Floor Level 13",
      "amount": "false",
      "description": "Floor Level 13",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86f4266ffae5022baa5bb299",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827028",
      "title": "Floor Level 15",
      "amount": "false",
      "description": "Floor Level 15",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41e71a6b978aaa0c4ca88601",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827029",
      "title": "Floor Level 16",
      "amount": "false",
      "description": "Floor Level 16",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3e2aff8ff7cdacd49d6e3cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827040",
      "title": "Floor Level 18",
      "amount": "false",
      "description": "Floor Level 18",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84ad3a1b2eded513c6736dae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827041",
      "title": "Floor Level 19",
      "amount": "false",
      "description": "Floor Level 19",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b45aab2cc0af0c407e64c140",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827042",
      "title": "Floor Level 21",
      "amount": "false",
      "description": "Floor Level 21",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_777435d808f7f31d1ed19850",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827043",
      "title": "Floor Level 22",
      "amount": "false",
      "description": "Floor Level 22",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_904845abac40270a455bb334",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827044",
      "title": "Floor Level 24",
      "amount": "false",
      "description": "Floor Level 24",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd559f9d65b9d2c0bed1b6c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827045",
      "title": "View North",
      "amount": "false",
      "description": "View North",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9024252de0fafabaff86ba4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827046",
      "title": "View Northeast",
      "amount": "false",
      "description": "View Northeast",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c168e49f42c238634293d7c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827047",
      "title": "View East",
      "amount": "false",
      "description": "View East",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_795388cccbacbb84a5cf5864",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827049",
      "title": "View Southeast",
      "amount": "false",
      "description": "View Southeast",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_601423e25182cf09f3e97fcd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827050",
      "title": "View South",
      "amount": "false",
      "description": "View South",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ede95a159c62e63a022a8ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827051",
      "title": "View Southwest",
      "amount": "false",
      "description": "View Southwest",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6df45765cef2d0c7a0446208",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827052",
      "title": "View West",
      "amount": "false",
      "description": "View West",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4447b177af91539e14cdd925",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "127827053",
      "title": "View Northwest",
      "amount": "false",
      "description": "View Northwest",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_96bb18eeb8763ec09cfa3a26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-8bdb-7020-a6e8-a580a53cf32e.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with closet and large window overlooking construction.",
        "public_id": "01a03794-8bdb-7020-a6e8-a580a53cf32e",
        "storage_key": "property/6767906449166934/01a03794-8bdb-7020-a6e8-a580a53cf32e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom featuring a walk-in closet, hardwood floors, and expansive windows with city views, including ongoing construction.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and a window overlooking a construction site.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(50).jpg"
    },
    {
      "id": "ec_05eaf02268b1aa3216ddead8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-c293-760a-a7f5-b5d07029cf57.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub/shower.",
        "public_id": "01a03794-c293-760a-a7f5-b5d07029cf57",
        "storage_key": "property/6767906449166934/01a03794-c293-760a-a7f5-b5d07029cf57.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a granite-top vanity, a sleek toilet, and a pristine bathtub with a shower.",
      "link": "false",
      "alt_text": "A white bathroom with a toilet, sink, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(49).jpg"
    },
    {
      "id": "ec_71c1782227eab2203a59ead0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-e070-708d-a125-a41c481e7448.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
        "public_id": "01a03794-e070-708d-a125-a41c481e7448",
        "storage_key": "property/6767906449166934/01a03794-e070-708d-a125-a41c481e7448.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample wood cabinetry for all your storage needs.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, oven, microwave, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(48).jpg"
    },
    {
      "id": "ec_33d96561dbeedc6e07aa6da2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-ea5b-7791-b62d-97114588ae32.webp",
      "image_media": {
        "alt_text": "Modern apartment living room and kitchen with city views",
        "public_id": "01a03794-ea5b-7791-b62d-97114588ae32",
        "storage_key": "property/6767906449166934/01a03794-ea5b-7791-b62d-97114588ae32.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living area and a sleek kitchen, with large windows offering stunning city views.",
      "link": "false",
      "alt_text": "A kitchen with wooden cabinets and a countertop with a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(47).jpg"
    },
    {
      "id": "ec_a768a3aa0e045d4e6b642d50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-d29b-7242-8677-ad956c70f7d4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors, ceiling fan, and large window overlooking city.",
        "public_id": "01a03794-d29b-7242-8677-ad956c70f7d4",
        "storage_key": "property/6767906449166934/01a03794-d29b-7242-8677-ad956c70f7d4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This empty bedroom features modern finishes including hardwood floors and a ceiling fan. A large window provides ample natural light and city views.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and a view of the city through the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(46).jpg"
    },
    {
      "id": "ec_2014f3b5c3cf61832bb98049",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-b954-755c-8d75-9a62414e0c25.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and white quartz countertops.",
        "public_id": "01a03794-b954-755c-8d75-9a62414e0c25",
        "storage_key": "property/6767906449166934/01a03794-b954-755c-8d75-9a62414e0c25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed kitchen, featuring sleek stainless steel appliances, rich wood cabinetry, and elegant white quartz countertops.",
      "link": "false",
      "alt_text": "A modern kitchen with wooden cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(45).jpg"
    },
    {
      "id": "ec_fb7944262bc21d99ffa280e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-e4d6-708b-bbdb-8769242f81e8.webp",
      "image_media": {
        "alt_text": "Balcony view of the Amazon Spheres and downtown Seattle skyscrapers",
        "public_id": "01a03794-e4d6-708b-bbdb-8769242f81e8",
        "storage_key": "property/6767906449166934/01a03794-e4d6-708b-bbdb-8769242f81e8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy stunning city views from your private balcony overlooking the iconic Amazon Spheres and downtown Seattle skyline.",
      "link": "false",
      "alt_text": "A balcony with a glass railing overlooks a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(44).jpg"
    },
    {
      "id": "ec_3dbe579b6be68b3f6c5e331b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03794-f427-71e3-bd4e-6c2dc11a965b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and quartz countertops.",
        "public_id": "01a03794-f427-71e3-bd4e-6c2dc11a965b",
        "storage_key": "property/6767906449166934/01a03794-f427-71e3-bd4e-6c2dc11a965b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, featuring sleek wood cabinetry, premium stainless steel appliances, and elegant quartz countertops. Perfect for any home chef.",
      "link": "false",
      "alt_text": "A kitchen with wooden cabinets and a marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(43).jpg"
    },
    {
      "id": "ec_d27581d704369e76605fd46d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-1dec-77ef-872a-893f6d6e0302.webp",
      "image_media": {
        "alt_text": "Empty living room with large windows and city views",
        "public_id": "01a03795-1dec-77ef-872a-893f6d6e0302",
        "storage_key": "property/6767906449166934/01a03795-1dec-77ef-872a-893f6d6e0302.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with abundant natural light and stunning city vistas.",
      "link": "false",
      "alt_text": "A room with a wooden floor and a window overlooking a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(42).jpg"
    },
    {
      "id": "ec_697458d72a2c9ddac956508f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-2240-72c8-a35d-2a188b20f75f.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a03795-2240-72c8-a35d-2a188b20f75f",
        "storage_key": "property/6767906449166934/01a03795-2240-72c8-a35d-2a188b20f75f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "A white wall with a wire shelf and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(41).jpg"
    },
    {
      "id": "ec_0fe7136287af72a625daa263",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-2c07-7740-9e39-535012b03ed2.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer next to a bathroom with toilet and shower.",
        "public_id": "01a03795-2c07-7740-9e39-535012b03ed2",
        "storage_key": "property/6767906449166934/01a03795-2c07-7740-9e39-535012b03ed2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit laundry with a stackable washer and dryer, conveniently located next to a full bathroom featuring a toilet and shower.",
      "link": "false",
      "alt_text": "A white washing machine and dryer in a small bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(40).jpg"
    },
    {
      "id": "ec_1bb96e2ade51d3f1d0d8ad1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-095d-71a8-ae62-a7471f87b69e.webp",
      "image_media": {
        "alt_text": "Clean white bathtub and shower area with tiled walls and chrome fixtures.",
        "public_id": "01a03795-095d-71a8-ae62-a7471f87b69e",
        "storage_key": "property/6767906449166934/01a03795-095d-71a8-ae62-a7471f87b69e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a white bathtub and shower with elegant tile work and gleaming chrome accents.",
      "link": "false",
      "alt_text": "A white bathroom with a tub and a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(39).jpg"
    },
    {
      "id": "ec_a50c821a64a176188e46236d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-1a03-74f0-8958-64f219625c91.webp",
      "image_media": {
        "alt_text": "Via Apartments building exterior with signage and street view.",
        "public_id": "01a03795-1a03-74f0-8958-64f219625c91",
        "storage_key": "property/6767906449166934/01a03795-1a03-74f0-8958-64f219625c91.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Exterior view of the Via Apartments building, showcasing the property's prominent signage and its integration with the surrounding urban environment and street-level businesses.",
      "link": "false",
      "alt_text": "A street view with a sign that says \"via\".",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(38).jpg"
    },
    {
      "id": "ec_ed08f9c78a78abce267964f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-d536-74db-9c0e-f3431308c1c5.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with a long table, chairs, and a grill on a wooden deck, with a modern building in the background.",
        "public_id": "019d01ac-d536-74db-9c0e-f3431308c1c5",
        "storage_key": "property/6767906449166934/019d01ac-d536-74db-9c0e-f3431308c1c5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling on the spacious deck, surrounded by lush greenery and urban views. Perfect for entertaining guests.",
      "link": "false",
      "alt_text": "A wooden table with chairs is set up on a wooden deck.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(37).jpg"
    },
    {
      "id": "ec_a280bf63ca34c4f5c184f0a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-e326-747f-8605-da77c33cf85b.webp",
      "image_media": {
        "alt_text": "Rooftop lounge with fireplace, seating areas, and city views.",
        "public_id": "019d01ac-e326-747f-8605-da77c33cf85b",
        "storage_key": "property/6767906449166934/019d01ac-e326-747f-8605-da77c33cf85b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the city skyline from our beautiful rooftop lounge, complete with a fireplace and comfortable seating.",
      "link": "false",
      "alt_text": "A wooden deck with a fireplace and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(36).jpg"
    },
    {
      "id": "ec_b848121f0dca0e10e33eab4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-bf98-727c-a14f-5bba31df9a37.webp",
      "image_media": {
        "alt_text": "Modern kitchen with large island, stainless steel appliances, and a TV.",
        "public_id": "019d01ac-bf98-727c-a14f-5bba31df9a37",
        "storage_key": "property/6767906449166934/019d01ac-bf98-727c-a14f-5bba31df9a37.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with bar seating, sleek stainless steel appliances, and a built-in television for entertainment.",
      "link": "false",
      "alt_text": "A modern kitchen with a wooden ceiling and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(35).jpg"
    },
    {
      "id": "ec_c174ca2e464ea76fd92157bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-3507-765a-bf6d-e6db5cfddcdc.webp",
      "image_media": {
        "alt_text": "Street view of a modern apartment building entrance with the VIA logo, surrounded by tall office buildings and the Amazon Spheres.",
        "public_id": "01a03795-3507-765a-bf6d-e6db5cfddcdc",
        "storage_key": "property/6767906449166934/01a03795-3507-765a-bf6d-e6db5cfddcdc.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Experience urban living at its finest. Our apartments are ideally located in the heart of the city, adjacent to iconic landmarks and offering easy access to the vibrant downtown atmosphere.",
      "link": "false",
      "alt_text": "A city street with a large metal sphere structure in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(34).jpg"
    },
    {
      "id": "ec_1d91aaec5ebfb039a14967a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a03795-36f8-771f-8335-0647c689204a.webp",
      "image_media": {
        "alt_text": "Modern lobby with a long bar, stools, and a seating area with a TV.",
        "public_id": "01a03795-36f8-771f-8335-0647c689204a",
        "storage_key": "property/6767906449166934/01a03795-36f8-771f-8335-0647c689204a.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to our stylish lobby, featuring a contemporary bar, comfortable seating, and a convenient workspace area, perfect for residents and guests.",
      "link": "false",
      "alt_text": "A wooden bar area with a TV on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(33).jpg"
    },
    {
      "id": "ec_6bc93463b68ef70e9af8b0ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-c746-73af-95e9-0adccb6df682.webp",
      "image_media": {
        "alt_text": "Pool table and kitchen island with bar stools in a modern apartment common area.",
        "public_id": "019d01ac-c746-73af-95e9-0adccb6df682",
        "storage_key": "property/6767906449166934/019d01ac-c746-73af-95e9-0adccb6df682.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the recreational amenities at our community, including a pool table and a full-service kitchen area, perfect for entertaining.",
      "link": "false",
      "alt_text": "A pool table is in the middle of a room with a bar and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(32).jpg"
    },
    {
      "id": "ec_8d65751e7e4a29fd655da4fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-cfbe-767a-8823-4360924cc842.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with modern seating, communal kitchen, and island.",
        "public_id": "019d01ac-cfbe-767a-8823-4360924cc842",
        "storage_key": "property/6767906449166934/019d01ac-cfbe-767a-8823-4360924cc842.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and entertain in our community lounge, featuring a fully equipped communal kitchen, comfortable seating areas, and a sleek island perfect for gatherings.",
      "link": "false",
      "alt_text": "A modern kitchen and dining area with a large island in the middle.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(31).jpg"
    },
    {
      "id": "ec_24faf1881147a90f18ca0554",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-c0c0-77aa-aa58-d254e78ee29d.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, ellipticals, and weightlifting equipment.",
        "public_id": "019d01ac-c0c0-77aa-aa58-d254e78ee29d",
        "storage_key": "property/6767906449166934/019d01ac-c0c0-77aa-aa58-d254e78ee29d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring state-of-the-art cardio machines and free weights.",
      "link": "false",
      "alt_text": "A gym with a row of exercise bikes and a variety of weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(30).jpg"
    },
    {
      "id": "ec_4df44fb2f3407c83d9f19970",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-df4e-765c-9a00-2ef29fb7f0a6.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with chaise lounges, tables, and a water feature, overlooking a cityscape.",
        "public_id": "019d01ac-df4e-765c-9a00-2ef29fb7f0a6",
        "storage_key": "property/6767906449166934/019d01ac-df4e-765c-9a00-2ef29fb7f0a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on our stylish rooftop lounge, complete with comfortable seating, a tranquil water feature, and stunning city views. Perfect for enjoying the outdoors and soaking up the sun.",
      "link": "false",
      "alt_text": "A wooden deck with a table and chairs overlooking a city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(29).jpg"
    },
    {
      "id": "ec_786370e6ca41cf6f20fac7e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-b9ed-723a-8b67-e2095972be11.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, weight machines, and free weights.",
        "public_id": "019d01ac-b9ed-723a-8b67-e2095972be11",
        "storage_key": "property/6767906449166934/019d01ac-b9ed-723a-8b67-e2095972be11.webp",
        "width": 3072,
        "height": 2024
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and weight training equipment.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including weights and machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(28).jpg"
    },
    {
      "id": "ec_51ae3a2ed30634936e52ad72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-ec3a-736f-8907-b1edda7b0854.webp",
      "image_media": {
        "alt_text": "View of downtown Seattle from a balcony, featuring modern skyscrapers and the Amazon Spheres.",
        "public_id": "019d01ac-ec3a-736f-8907-b1edda7b0854",
        "storage_key": "property/6767906449166934/019d01ac-ec3a-736f-8907-b1edda7b0854.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from your private balcony, overlooking the vibrant downtown Seattle skyline and the iconic Amazon Spheres. Experience urban living at its finest.",
      "link": "false",
      "alt_text": "A view from a high-rise building looking down at a large, spherical sculpture in the middle of a park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(27).jpg"
    },
    {
      "id": "ec_c7b4574e83f1fbf50f491275",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ac-9ba0-7394-9612-e6d0368165ed.webp",
      "image_media": {
        "alt_text": "Bathroom with a wood vanity, marble countertop, LED mirror, and toilet.",
        "public_id": "019d01ac-9ba0-7394-9612-e6d0368165ed",
        "storage_key": "property/6767906449166934/019d01ac-9ba0-7394-9612-e6d0368165ed.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a sleek wood vanity with a marble countertop, a large LED-lit mirror, and a clean white toilet. Perfect for any apartment.",
      "link": "false",
      "alt_text": "A white sink with a mirror above it and a toilet in the corner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Via6_Favorites%20(26).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_47b07686-31f2-47fb-8ff1-b2c6b876f583",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Rubinstein Bagels South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "2121 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Bagel shop offering a variety of flavors, including vegan, using an organic sourdough culture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b209-761a-8b8b-3aa2c91c937a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b209-761a-8b8b-3aa2c91c937a",
        "storage_key": "property/6767906449166934/019d01ad-b209-761a-8b8b-3aa2c91c937a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rubinsteinbagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6957892144180325486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rubinstein-bagels-south-lake-union",
      "poi_latitude": "47.6153512",
      "poi_longitude": "-122.3404186",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-550-1666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWW-rp9rkFQRbmxZZwpmj2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_e649e423-2bc5-4402-b7c0-b6c5d6ec9666",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The Victor Tavern - 6th & Lenora",
      "poi_type": "Restaurants",
      "poi_address": "2121 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Chic, streamlined eatery serving classic salads, burgers & desserts, plus cocktails & happy hours.",
      "poi_long_description": "Chic, streamlined eatery serving classic salads, burgers & desserts, plus cocktails & happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b20d-7557-9aff-e64b93c47965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b20d-7557-9aff-e64b93c47965",
        "storage_key": "property/6767906449166934/019d01ad-b20d-7557-9aff-e64b93c47965.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://victortavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13462903966744734619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-victor-tavern---6th--lenora",
      "poi_latitude": "47.6153686",
      "poi_longitude": "-122.3403288",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-649-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a80-77bc-93d8-7c1d180c4f74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a80-77bc-93d8-7c1d180c4f74",
        "storage_key": "property/6767906449166934/019d01ae-2a80-77bc-93d8-7c1d180c4f74.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fJh2RoVkFQRm2sEB9TX1bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_7fcc9d46-f4bb-46c4-90d1-5721ee4aa017",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Willmott's Ghost",
      "poi_type": "Restaurants",
      "poi_address": "2100 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "A menu specializing in Roman cuisine & pizza in a modern setting with natural light & pastel decor.",
      "poi_long_description": "A menu specializing in Roman cuisine & pizza in a modern setting with natural light & pastel decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b256-746c-ba86-c9e28f414535.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b256-746c-ba86-c9e28f414535",
        "storage_key": "property/6767906449166934/019d01ad-b256-746c-ba86-c9e28f414535.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.willmottsghost.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9083017492105551473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willmotts-ghost",
      "poi_latitude": "47.615443",
      "poi_longitude": "-122.3396126",
      "poi_miles_from_property": "0.08",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-900-9650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQRNuEsVkFQRcV6cAUlcDX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5a930937-63a6-4985-930f-df99581ca3d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "2120",
      "poi_type": "Restaurants",
      "poi_address": "2120 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Chic, contemporary eatery with a patio, serving inventive New American fare, cocktails, and local wines.",
      "poi_long_description": "Chic, contemporary eatery with a patio, serving inventive New American fare, cocktails, and local wines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b234-73aa-976a-2a9061de633e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b234-73aa-976a-2a9061de633e",
        "storage_key": "property/6767906449166934/019d01ad-b234-73aa-976a-2a9061de633e.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.2120restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7077915409849202424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "2120",
      "poi_latitude": "47.6156966",
      "poi_longitude": "-122.3402339",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-829-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cTwwEsVkFQR-DZTmpDOOWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3f4f400f-4bcf-4985-93c6-6d10dbdab9a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Marination",
      "poi_type": "Restaurants",
      "poi_address": "2000 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Laid-back Hawaiian-Korean restaurant doling out tacos, sliders & kimchi rice bowls.",
      "poi_long_description": "Laid-back Hawaiian-Korean restaurant doling out tacos, sliders & kimchi rice bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b848-751f-8174-2f8bd7586970.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b848-751f-8174-2f8bd7586970",
        "storage_key": "property/6767906449166934/019d01ad-b848-751f-8174-2f8bd7586970.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.marinationmobile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11750115297760253619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marination",
      "poi_latitude": "47.6146302",
      "poi_longitude": "-122.3383121",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-327-9860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzFUr0sVkFQRsxbiyJvLEKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_615b6d7f-9933-4b5b-9270-61f6f39e9b60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Casco Antiguo",
      "poi_type": "Restaurants",
      "poi_address": "2102 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Brick-walled space for Mexican classics prepared by hand, plus margaritas on tap.",
      "poi_long_description": "Brick-walled space for Mexican classics prepared by hand, plus margaritas on tap.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b863-73ed-8136-663d004cbd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b863-73ed-8136-663d004cbd83",
        "storage_key": "property/6767906449166934/019d01ad-b863-73ed-8136-663d004cbd83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cascoantiguorestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674294639961558379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casco-antiguo",
      "poi_latitude": "47.6162114",
      "poi_longitude": "-122.3386504",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-610-1792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5W7wFhcVkFQRa80_sBpKPBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8f0c7298-fb39-4800-9341-cddefa951c19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The Butcher's Table",
      "poi_type": "Restaurants",
      "poi_address": "2121 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Sleek steakhouse and takeaway butcher counter, offering classic preparations and prime Wagyu cuts.",
      "poi_long_description": "Sleek steakhouse and takeaway butcher counter, offering classic preparations and prime Wagyu cuts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b88f-740d-a01f-77ea194b6703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b88f-740d-a01f-77ea194b6703",
        "storage_key": "property/6767906449166934/019d01ad-b88f-740d-a01f-77ea194b6703.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.thebutcherstable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11507511410303237173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-butchers-table",
      "poi_latitude": "47.6174437",
      "poi_longitude": "-122.3386263",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 206-209-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpylJiEkVkFQRNfzgg6jksp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_992c891a-a839-4249-8c59-32523c2cf976",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Cinque Terre Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "2001 Westlake Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Serves regional Italian dishes, seafood, and cocktails in a minimalist space.",
      "poi_long_description": "Serves regional Italian dishes, seafood, and cocktails in a minimalist space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-b863-73ed-8136-6b1b681129c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-b863-73ed-8136-6b1b681129c4",
        "storage_key": "property/6767906449166934/019d01ad-b863-73ed-8136-6b1b681129c4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.cinqueterreseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16266704932814038830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinque-terre-ristorante",
      "poi_latitude": "47.6150536",
      "poi_longitude": "-122.3380046",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-456-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SMKqUsVkFQRLqd5ovPxvuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a6d3b389-dd70-4fc9-b7f0-131360d60295",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Barolo Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "1940 Westlake Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Sparkling chandeliers & gauzy drapes set the sophisticated mood at this upscale Italian restaurant.",
      "poi_long_description": "Sparkling chandeliers & gauzy drapes set the sophisticated mood at this upscale Italian restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-be0f-7436-b492-e9c3e4748308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-be0f-7436-b492-e9c3e4748308",
        "storage_key": "property/6767906449166934/019d01ad-be0f-7436-b492-e9c3e4748308.webp",
        "width": 480,
        "height": 313
      },
      "poi_business_url": "http://baroloseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14174782157256411308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barolo-ristorante",
      "poi_latitude": "47.6146633",
      "poi_longitude": "-122.3374525",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-770-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6U7AksVkFQRrEjQU0XxtsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6e13ef2c-9d24-4f71-a421-2efd494f4b02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Serious Pie & Biscuit",
      "poi_type": "Restaurants",
      "poi_address": "401 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Pizzeria offering ultrathin crusts & inventive toppings, served in a large space with loft seating.",
      "poi_long_description": "Pizzeria offering ultrathin crusts & inventive toppings, served in a large space with loft seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-bf01-779e-828e-30e454a098ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-bf01-779e-828e-30e454a098ec",
        "storage_key": "property/6767906449166934/019d01ad-bf01-779e-828e-30e454a098ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seriouspieseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733392542236399940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serious-pie--biscuit",
      "poi_latitude": "47.6221689",
      "poi_longitude": "-122.3387163",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-436-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_EqkDcVkFQRRNkrH9zzOOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5887a1dd-a262-477c-b9ee-6dbd58b8e7cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Paju",
      "poi_type": "Restaurants",
      "poi_address": "513 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Snug, simple restaurant offering contemporary, inventive takes on traditional Korean cuisine.",
      "poi_long_description": "Snug, simple restaurant offering contemporary, inventive takes on traditional Korean cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-bee8-7202-9e1e-9c7a12122b57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-bee8-7202-9e1e-9c7a12122b57",
        "storage_key": "property/6767906449166934/019d01ad-bee8-7202-9e1e-9c7a12122b57.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pajurestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7985221622297603729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paju",
      "poi_latitude": "47.62383",
      "poi_longitude": "-122.3386788",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-829-8215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcSoyoEVkFQRkS7RCcI00W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_eb9e9236-2fa2-4a17-af89-879c305999b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Portage Bay Cafe - South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "391 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Bustling, bright cafe serving local, organic & seasonal breakfast, brunch & lunch dishes.",
      "poi_long_description": "Bustling, bright cafe serving local, organic & seasonal breakfast, brunch & lunch dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-beec-71a5-8821-b0e55b0bc85e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-beec-71a5-8821-b0e55b0bc85e",
        "storage_key": "property/6767906449166934/019d01ad-beec-71a5-8821-b0e55b0bc85e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portagebaycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13067652949942653666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portage-bay-cafe---south-lake-union",
      "poi_latitude": "47.621843",
      "poi_longitude": "-122.337419",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-462-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZC5oTcVkFQR4tJqYR-hWbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_845fc8da-e5d9-4ce6-9c36-f37a22310d24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Dahlia Bakery",
      "poi_type": "Restaurants",
      "poi_address": "2001 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Snug bakery serving breakfast fare & pastries along with sandwiches & signature coconut cream pie.",
      "poi_long_description": "Snug bakery serving breakfast fare & pastries along with sandwiches & signature coconut cream pie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c37c-70ae-b146-0b19fec08fc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c37c-70ae-b146-0b19fec08fc5",
        "storage_key": "property/6767906449166934/019d01ad-c37c-70ae-b146-0b19fec08fc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dahliabakery.com/?utm_source=gbp&utm_medium=organic&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4350621720964367211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dahlia-bakery",
      "poi_latitude": "47.613111",
      "poi_longitude": "-122.340459",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-441-4540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0jTnUwVkFQRawMulmeDYDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_81652e34-a9e3-4790-89af-32896ede25b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Café Hagen Modern European Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1252 Thomas St, Seattle, WA 98109, USA",
      "poi_short_description": "Stylish, window-filled space serving specialty coffee drinks & Scandinavian brunch/lunch fare.",
      "poi_long_description": "Stylish, window-filled space serving specialty coffee drinks & Scandinavian brunch/lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c344-719c-9616-f270ae200a44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c344-719c-9616-f270ae200a44",
        "storage_key": "property/6767906449166934/019d01ad-c344-719c-9616-f270ae200a44.webp",
        "width": 485,
        "height": 606
      },
      "poi_business_url": "http://cafehagen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2083651955621658302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-hagen-modern-european-cafe",
      "poi_latitude": "47.6210768",
      "poi_longitude": "-122.331414",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-913-2847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30hA4soVkFQRvn5g-mme6hw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_67cd1158-5110-41a7-84af-51daf3406de7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The 5 Point Cafe",
      "poi_type": "Restaurants",
      "poi_address": "415 Cedar St, Seattle, WA 98121, USA",
      "poi_short_description": "Circa-1929 American diner open 24/7 serving hearty all-day breakfasts, burgers & hot sandwiches.",
      "poi_long_description": "Circa-1929 American diner open 24/7 serving hearty all-day breakfasts, burgers & hot sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c423-713c-a9ac-bdb29fbe6612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c423-713c-a9ac-bdb29fbe6612",
        "storage_key": "property/6767906449166934/019d01ad-c423-713c-a9ac-bdb29fbe6612.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.the5pointcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471903945836826826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5-point-cafe",
      "poi_latitude": "47.6180712",
      "poi_longitude": "-122.3473786",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-448-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a46-72bb-8236-f5a44231cf5e",
        "storage_key": "property/6767906449166934/019d01ae-2a46-72bb-8236-f5a44231cf5e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibX4ME8VkFQRypD16V31l-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_bf27c2a8-9823-460a-930e-8dbf13d486a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Wally's Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "2129 2nd Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c438-70b1-b5d4-0f686f475d83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c438-70b1-b5d4-0f686f475d83",
        "storage_key": "property/6767906449166934/019d01ad-c438-70b1-b5d4-0f686f475d83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14595894418347272841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wallys-grocery",
      "poi_latitude": "47.612966",
      "poi_longitude": "-122.3441485",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-728-1366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwejVUwVkFQRiSqyIKQIj8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_22cda60d-7e7f-4d6f-8cff-26a45333df69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Belltown Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "2221 3rd Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Compact food store selling a broad array of grocery items, plus premade gourmet sandwiches.",
      "poi_long_description": "Compact food store selling a broad array of grocery items, plus premade gourmet sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-ca23-74e7-842a-de988481073c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-ca23-74e7-842a-de988481073c",
        "storage_key": "property/6767906449166934/019d01ad-ca23-74e7-842a-de988481073c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15698169554662695837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belltown-grocery",
      "poi_latitude": "47.6142073",
      "poi_longitude": "-122.3444919",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-441-0220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_FMP0wVkFQRnaOFmQka29k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7d6091ac-3913-4927-af88-f693dcf1f770",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Abyssinia Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2225 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Grocery store offering beer, plus sandwiches, in an environment where some say staff is friendly.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c982-7569-8238-a60df29ee038.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c982-7569-8238-a60df29ee038",
        "storage_key": "property/6767906449166934/019d01ad-c982-7569-8238-a60df29ee038.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18310427234463633980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abyssinia-market",
      "poi_latitude": "47.6151351",
      "poi_longitude": "-122.343945",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-770-9418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf02YEEwVkFQRPNLXk460G_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_61bd0152-683f-4826-9761-f32387a8bb54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Belltown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2424 1st Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Casual convenience store for basic groceries, household products, wine & beer.",
      "poi_long_description": "Casual convenience store for basic groceries, household products, wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-c9b5-706d-9393-5a43f11c2f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-c9b5-706d-9393-5a43f11c2f88",
        "storage_key": "property/6767906449166934/019d01ad-c9b5-706d-9393-5a43f11c2f88.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3865251742691289097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belltown-market",
      "poi_latitude": "47.61473669999999",
      "poi_longitude": "-122.3485197",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-443-9433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsUTDc04VkFQRCeiSIvshpDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8e357483-017c-4ccd-8670-934d70aa527d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "City Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2522 5th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Corner store carrying groceries, beer, and sandwiches, plus cigarettes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-cc2f-71d8-9b58-165bb3bc3684.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-cc2f-71d8-9b58-165bb3bc3684",
        "storage_key": "property/6767906449166934/019d01ad-cc2f-71d8-9b58-165bb3bc3684.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12089212766479948068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-foods",
      "poi_latitude": "47.6179809",
      "poi_longitude": "-122.3457059",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-728-2275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG5vILEkVkFQRJJknsPWCxac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_13ee655e-8c9f-47ff-90e0-90cf748bd23d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Capsule",
      "poi_type": "Shopping & Retail",
      "poi_address": "2033 6th Ave Suite 120, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-cfd4-75ac-9312-6d911959d736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-cfd4-75ac-9312-6d911959d736",
        "storage_key": "property/6767906449166934/019d01ad-cfd4-75ac-9312-6d911959d736.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.capsule.com/get-started?utm_source=GMBlisting&utm_medium=organic&utm_campaign=Seattle-WA",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816396203515561242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capsule",
      "poi_latitude": "47.614592",
      "poi_longitude": "-122.3391944",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-338-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a48-7684-b1c0-4b630a29adba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a48-7684-b1c0-4b630a29adba",
        "storage_key": "property/6767906449166934/019d01ae-2a48-7684-b1c0-4b630a29adba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0O5qE0VkFQRGsXRu71F_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e6ef6a5f-43b9-47e4-a61e-e7437ccc3b25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Neighborcare Health at Pike Place Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1930 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d0c2-765d-8e49-7bd324fe1157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d0c2-765d-8e49-7bd324fe1157",
        "storage_key": "property/6767906449166934/019d01ad-d0c2-765d-8e49-7bd324fe1157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neighborcare.org/clinics/pike-place-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2422229298398197556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neighborcare-health-at-pike-place-market",
      "poi_latitude": "47.6107392",
      "poi_longitude": "-122.3427303",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-728-4143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTDtzbJqkFQRNHeRn7Z8nSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_7de930f4-8156-4da2-94f0-326c0101bb4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d094-77ad-b957-40046a687439.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d094-77ad-b957-40046a687439",
        "storage_key": "property/6767906449166934/019d01ad-d094-77ad-b957-40046a687439.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d030b4e8-64d1-4bf7-bdb5-c8192ed1c6e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d14f-76cb-afae-1b2693479545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d14f-76cb-afae-1b2693479545",
        "storage_key": "property/6767906449166934/019d01ad-d14f-76cb-afae-1b2693479545.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/seattle-pike-plaza/2786",
      "poi_directions_map_url": "https://maps.google.com/?cid=2472263421707813677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "47.609012",
      "poi_longitude": "-122.3390475",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-494-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0e-71d8-85a0-0b0e86f3827b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0e-71d8-85a0-0b0e86f3827b",
        "storage_key": "property/6767906449166934/019d01ae-2e0e-71d8-85a0-0b0e86f3827b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6SynALNqkFQRLQMWwns-TyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5acd21da-54ad-42bd-a5b4-253d6e69cac9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "H Mart Downtown Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "1601 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Compact, downtown spot boasting a large selection of Asian groceries, plus sushi and ramen counters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d5c0-766e-aa8a-a38fd8cf8a7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d5c0-766e-aa8a-a38fd8cf8a7c",
        "storage_key": "property/6767906449166934/019d01ad-d5c0-766e-aa8a-a38fd8cf8a7c.webp",
        "width": 1280,
        "height": 1163
      },
      "poi_business_url": "http://hmartus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924453621694210560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-mart-downtown-seattle",
      "poi_latitude": "47.61027",
      "poi_longitude": "-122.3402051",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-677-0345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a3c-7334-955c-5626efaaf59d",
        "storage_key": "property/6767906449166934/019d01ae-2a3c-7334-955c-5626efaaf59d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQcALZNrkFQRACLMa18ItRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_e0dc5605-3f69-455e-b166-00745af08ae4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Lowell Elementary School",
      "poi_type": "Education",
      "poi_address": "1058 E Mercer St, Seattle, WA 98102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d603-73fa-aaa6-4c7523031da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d603-73fa-aaa6-4c7523031da7",
        "storage_key": "property/6767906449166934/019d01ad-d603-73fa-aaa6-4c7523031da7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lowelles.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7684766049611696728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowell-elementary-school",
      "poi_latitude": "47.62483630000001",
      "poi_longitude": "-122.3182546",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-252-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeyn8pC4VkFQRWEoWqQHGpWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fd25e661-a632-4f03-9944-2278a28ccbb0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Edmond S Meany Middle School",
      "poi_type": "Education",
      "poi_address": "301 21st Ave E, Seattle, WA 98112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d6e4-71e9-be4f-69cce6257284.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d6e4-71e9-be4f-69cce6257284",
        "storage_key": "property/6767906449166934/019d01ad-d6e4-71e9-be4f-69cce6257284.webp",
        "width": 1181,
        "height": 631
      },
      "poi_business_url": "http://meanyms.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5771863045694363163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edmond-s-meany-middle-school",
      "poi_latitude": "47.62182689999999",
      "poi_longitude": "-122.3050484",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-413-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEbcpqSoVkFQRGxbRAtzGGVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2b25a3f0-1881-405d-a737-d353bf5fafa9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Garfield High School",
      "poi_type": "Education",
      "poi_address": "400 23rd Ave, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-d86b-7094-ba01-3499b5105d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-d86b-7094-ba01-3499b5105d42",
        "storage_key": "property/6767906449166934/019d01ad-d86b-7094-ba01-3499b5105d42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garfieldhs.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2974457091223332753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garfield-high-school",
      "poi_latitude": "47.605334",
      "poi_longitude": "-122.301807",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-252-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaztWtlYUkFQRkScCEvdkRyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a2cdc1e2-7c0f-4d35-8c3f-598eb5dab1b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-db84-75d0-b6f9-d488c7781314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-db84-75d0-b6f9-d488c7781314",
        "storage_key": "property/6767906449166934/019d01ad-db84-75d0-b6f9-d488c7781314.webp",
        "width": 1280,
        "height": 810
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_01dba109-7264-4acf-89aa-598f5489e28f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle University",
      "poi_type": "Education",
      "poi_address": "901 12th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-dbc1-731f-836c-5ab80276f35f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-dbc1-731f-836c-5ab80276f35f",
        "storage_key": "property/6767906449166934/019d01ad-dbc1-731f-836c-5ab80276f35f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887710188514951233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-university",
      "poi_latitude": "47.6091765",
      "poi_longitude": "-122.3178465",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZv0y8hqkFQRQcB9L4Wi1EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bb0ea4ab-8f10-4381-be58-c1b5d1d7c470",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Cornish College of the Arts at Seattle University",
      "poi_type": "Education",
      "poi_address": "1000 Lenora St, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-dbd6-70a9-8462-256903026f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-dbd6-70a9-8462-256903026f7f",
        "storage_key": "property/6767906449166934/019d01ad-dbd6-70a9-8462-256903026f7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cornish.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16527929581452341339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornish-college-of-the-arts-at-seattle-university",
      "poi_latitude": "47.6181961",
      "poi_longitude": "-122.3362411",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQaIjBzYVkFQRWzAjt2IAX-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f49ceb59-55e5-4904-84a4-647bbfae66e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Bright Horizons at South Lake Union",
      "poi_type": "Education",
      "poi_address": "1275 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Well-run day care center, also offering preschool and kindergarten prep, that cares for kids from infancy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-ddb3-7232-af12-d52e462e1576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-ddb3-7232-af12-d52e462e1576",
        "storage_key": "property/6767906449166934/019d01ad-ddb3-7232-af12-d52e462e1576.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://child-care-preschool.brighthorizons.com/wa/seattle/slu?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=5021915168119637467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-south-lake-union",
      "poi_latitude": "47.6239936",
      "poi_longitude": "-122.3308231",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-573-5428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ07Tp8jAVkFQR28Xq9zxtsUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_0ee09abd-bb99-4aad-b321-3c65d651e214",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle KinderCare",
      "poi_type": "Education",
      "poi_address": "1827 8th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e079-71b6-908a-bdda8d5100f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e079-71b6-908a-bdda8d5100f2",
        "storage_key": "property/6767906449166934/019d01ad-e079-71b6-908a-bdda8d5100f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/seattle/wa/301786?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA4MTE0LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12819176838282673811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-kindercare",
      "poi_latitude": "47.6146137",
      "poi_longitude": "-122.3353332",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-903-1103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJccSg60oVkFQRk_7AXmrd5rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b55ddc89-ceb0-46f9-b7a1-d16e93788493",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Young Child Academy of Greenwood",
      "poi_type": "Education",
      "poi_address": "9218 Greenwood Ave N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e0b8-74cb-9bc9-def0525a31cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e0b8-74cb-9bc9-def0525a31cc",
        "storage_key": "property/6767906449166934/019d01ad-e0b8-74cb-9bc9-def0525a31cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://youngchildacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11863609156017726698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "young-child-academy-of-greenwood",
      "poi_latitude": "47.6967205",
      "poi_longitude": "-122.354879",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-282-7132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwiqpjgVkFQR6iSC2qsBpKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0afd6200-a19b-4c4d-836f-001064774c75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Harvard Avenue School",
      "poi_type": "Education",
      "poi_address": "201 Harvard Ave E, Seattle, WA 98102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e08a-7756-8dbb-64e08b9e3a61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e08a-7756-8dbb-64e08b9e3a61",
        "storage_key": "property/6767906449166934/019d01ad-e08a-7756-8dbb-64e08b9e3a61.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "http://www.harvardavenueschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7015002056604506306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harvard-avenue-school",
      "poi_latitude": "47.6200602",
      "poi_longitude": "-122.3224991",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-329-5187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK5HDYDIVkFQRwtiLEjRLWmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_8dd4585b-4cdd-402f-84e1-54a36d61741b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1300 1st Ave, Seattle, WA 98101, USA",
      "poi_short_description": "This roomy space hosts special exhibits & a permanent collection of both current & classic artworks.",
      "poi_long_description": "This roomy space hosts special exhibits & a permanent collection of both current & classic artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e309-7030-aff8-00c95f6f6f18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e309-7030-aff8-00c95f6f6f18",
        "storage_key": "property/6767906449166934/019d01ad-e309-7030-aff8-00c95f6f6f18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8891487675925302724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-art-museum",
      "poi_latitude": "47.6075253",
      "poi_longitude": "-122.3379599",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e23-776c-9e19-dc7f770cfcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e23-776c-9e19-dc7f770cfcf2",
        "storage_key": "property/6767906449166934/019d01ae-2e23-776c-9e19-dc7f770cfcf2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxh5JbJqkFQRxI1KoO7oZHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1778dff3-daae-4973-be2c-05ca6f22d0b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Museum of Pop Culture",
      "poi_type": "Entertainment",
      "poi_address": "325 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_long_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e51f-700b-b1c0-9a06af7652ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e51f-700b-b1c0-9a06af7652ad",
        "storage_key": "property/6767906449166934/019d01ad-e51f-700b-b1c0-9a06af7652ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mopop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125666784235608082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-pop-culture",
      "poi_latitude": "47.6214824",
      "poi_longitude": "-122.3481245",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-770-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e23-776c-9e19-dc7f770cfcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e23-776c-9e19-dc7f770cfcf2",
        "storage_key": "property/6767906449166934/019d01ae-2e23-776c-9e19-dc7f770cfcf2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8p6-EYVkFQREthJEc0p6dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6c04e49f-d0d6-44e7-b6a3-94a9cc195c0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1483 Alaskan Way Pier 59, Seattle, WA 98101, USA",
      "poi_short_description": "Popular waterfront aquarium with interactive exhibits, a cafe & virtual reality shows.",
      "poi_long_description": "Popular waterfront aquarium with interactive exhibits, a cafe & virtual reality shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e616-754f-80ac-b0ab18ad568b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e616-754f-80ac-b0ab18ad568b",
        "storage_key": "property/6767906449166934/019d01ad-e616-754f-80ac-b0ab18ad568b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753481524406941315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-aquarium",
      "poi_latitude": "47.6074002",
      "poi_longitude": "-122.3429559",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-386-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_oEiK1qkFQRg3bU4l3mmWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_6a63fd1f-310f-4066-98b0-bdfa9ab3d725",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The Seattle Great Wheel",
      "poi_type": "Entertainment",
      "poi_address": "1301 Alaskan Wy, Seattle, WA 98101, USA",
      "poi_short_description": "Giant Ferris wheel offering climate-controlled gondolas & a bird's-eye view of the city's landmarks.",
      "poi_long_description": "Giant Ferris wheel offering climate-controlled gondolas & a bird's-eye view of the city's landmarks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e862-728e-9d25-d842c2ed7cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e862-728e-9d25-d842c2ed7cfd",
        "storage_key": "property/6767906449166934/019d01ad-e862-728e-9d25-d842c2ed7cfd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://seattlegreatwheel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11898669042848881350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-seattle-great-wheel",
      "poi_latitude": "47.6061342",
      "poi_longitude": "-122.3425246",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-623-8607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUX-M-a1qkFQRxtrx3nOQIKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferris_wheel"
    },
    {
      "id": "custom_46ade770-21b2-4108-bff7-ea4362ee2d17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "SIFF Cinema Downtown",
      "poi_type": "Entertainment",
      "poi_address": "2100 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Cinema featuring first-run & classic films, plus concessions such as craft beer & chocolate popcorn.",
      "poi_long_description": "Cinema featuring first-run & classic films, plus concessions such as craft beer & chocolate popcorn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-ea24-77c8-a820-7a6ebc7e1f71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-ea24-77c8-a820-7a6ebc7e1f71",
        "storage_key": "property/6767906449166934/019d01ad-ea24-77c8-a820-7a6ebc7e1f71.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.siff.net/cinema/cinema-venues/siff-cinema-downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=11586733313440549329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siff-cinema-downtown",
      "poi_latitude": "47.614043",
      "poi_longitude": "-122.3412806",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-464-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-320c-77dc-af5b-3211c7e63d1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-320c-77dc-af5b-3211c7e63d1b",
        "storage_key": "property/6767906449166934/019d01ae-320c-77dc-af5b-3211c7e63d1b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzsYf0wVkFQR0QnPNo9YzKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2c12c6a2-4dfb-43d3-83ef-ca82d9cc28e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Paramount Theatre",
      "poi_type": "Entertainment",
      "poi_address": "911 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_long_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-eb0f-71e3-8e5f-4a12f37a9dd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-eb0f-71e3-8e5f-4a12f37a9dd8",
        "storage_key": "property/6767906449166934/019d01ad-eb0f-71e3-8e5f-4a12f37a9dd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stgpresents.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7759253808531622023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paramount-theatre",
      "poi_latitude": "47.6135244",
      "poi_longitude": "-122.3315134",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-682-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWjwULVqkFQRh8ifgzporms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_23e8e00b-7b5c-4bad-94a2-c64701e80470",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The 5th Avenue Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1308 5th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Restored 1926 vaudeville theater with an ornate, Chinese-inspired interior now hosting musicals.",
      "poi_long_description": "Restored 1926 vaudeville theater with an ornate, Chinese-inspired interior now hosting musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-eb11-724e-a68b-bdb81d246e2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-eb11-724e-a68b-bdb81d246e2d",
        "storage_key": "property/6767906449166934/019d01ad-eb11-724e-a68b-bdb81d246e2d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.5thavenue.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14800425353492837045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5th-avenue-theatre",
      "poi_latitude": "47.609188",
      "poi_longitude": "-122.3338546",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-625-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoT6vDbRqkFQRtTKgZ3GsZc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ea32307c-dd25-4e0f-b777-86165be0b8f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The Showbox",
      "poi_type": "Entertainment",
      "poi_address": "1426 1st Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Local acts & well-known bands perform at this big rock club that includes a separate bar & eatery.",
      "poi_long_description": "Local acts & well-known bands perform at this big rock club that includes a separate bar & eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-ee43-74ec-bc67-ea72ba54ab1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-ee43-74ec-bc67-ea72ba54ab1f",
        "storage_key": "property/6767906449166934/019d01ad-ee43-74ec-bc67-ea72ba54ab1f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.showboxpresents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16700364504578446495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-showbox",
      "poi_latitude": "47.6085565",
      "poi_longitude": "-122.3393269",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-628-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRCaVrJqkFQRn9Tw2gidw-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_5898b38b-9fe9-4e0e-b968-04e729634eed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "The Triple Door",
      "poi_type": "Entertainment",
      "poi_address": "216 Union St, Seattle, WA 98101, USA",
      "poi_short_description": "Lounge in a historic theater featuring diverse live-music acts.",
      "poi_long_description": "Lounge in a historic theater featuring diverse live-music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-efa7-723e-b7bb-d4657cd7cef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-efa7-723e-b7bb-d4657cd7cef9",
        "storage_key": "property/6767906449166934/019d01ad-efa7-723e-b7bb-d4657cd7cef9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thetripledoor.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15149986198273080130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-triple-door",
      "poi_latitude": "47.6086955",
      "poi_longitude": "-122.3374174",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-838-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2xeRu7NqkFQRQjsj5C2QP9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_366ac8b0-aeb6-400b-bcd0-e5975a21d2c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Virginia Mason Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 9th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f0f4-72dd-960e-1cbd4c9993eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f0f4-72dd-960e-1cbd4c9993eb",
        "storage_key": "property/6767906449166934/019d01ad-f0f4-72dd-960e-1cbd4c9993eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/virginia-mason-medical-center.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908412116613558774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-mason-medical-center",
      "poi_latitude": "47.609935",
      "poi_longitude": "-122.3275125",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-624-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3215-72db-9df5-0e74393eed44",
        "storage_key": "property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3kMjY8NkFQR9nFRWgZ3Ypc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ceeba443-6252-42e2-a906-3b9e82bb5e4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f097-71bf-aea1-b33229ec136e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f097-71bf-aea1-b33229ec136e",
        "storage_key": "property/6767906449166934/019d01ad-f097-71bf-aea1-b33229ec136e.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3215-72db-9df5-0e74393eed44",
        "storage_key": "property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7aca2351-ecf4-4103-8f25-9dfc070ec2a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "ZoomCare Urgent Care - Belltown",
      "poi_type": "Health and Wellness",
      "poi_address": "2720 3rd Ave #2, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f3b4-7309-9231-dd25f21610a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f3b4-7309-9231-dd25f21610a8",
        "storage_key": "property/6767906449166934/019d01ad-f3b4-7309-9231-dd25f21610a8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-belltown?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=belltown",
      "poi_directions_map_url": "https://maps.google.com/?cid=529952981612014560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoomcare-urgent-care---belltown",
      "poi_latitude": "47.617663",
      "poi_longitude": "-122.3491949",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwh3y00VkFQR4Kuk0G3FWgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_d8d35fd3-db61-4308-b828-6ea6ddad8be8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f452-7709-9e9e-dcd2ddc5b74a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f452-7709-9e9e-dcd2ddc5b74a",
        "storage_key": "property/6767906449166934/019d01ad-f452-7709-9e9e-dcd2ddc5b74a.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/seattle-wa-pharmacies/1401-2nd-ave-seattle-wa-98101/storeid=17637?WT.mc_id=LS_GOOGLE_RX_17637",
      "poi_directions_map_url": "https://maps.google.com/?cid=18362573376409185836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "47.608455",
      "poi_longitude": "-122.3386291",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-494-3251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2a48-7684-b1c0-4b630a29adba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2a48-7684-b1c0-4b630a29adba",
        "storage_key": "property/6767906449166934/019d01ae-2a48-7684-b1c0-4b630a29adba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTJ2s7NqkFQRLC7qXjL31P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_871944e6-18a2-4ca2-8f0e-17bb5b97fa20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "951 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f55f-7169-8394-2c40a9aee68f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f55f-7169-8394-2c40a9aee68f",
        "storage_key": "property/6767906449166934/019d01ad-f55f-7169-8394-2c40a9aee68f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-951+mercer+st-seattle-wa-98109/id=21452",
      "poi_directions_map_url": "https://maps.google.com/?cid=8774373187664277877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "47.6243732",
      "poi_longitude": "-122.338026",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-701-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WYYXskVkFQRdfFw8ezVxHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_dc97565a-f53c-4992-a5aa-a97cda9b3aa8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Washington Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1325 6th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Upscale 21-story athletic club featuring 10-story lodgings, restaurants and a pool, plus a spa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f664-700c-b972-f2c6630508f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f664-700c-b972-f2c6630508f6",
        "storage_key": "property/6767906449166934/019d01ad-f664-700c-b972-f2c6630508f6.webp",
        "width": 712,
        "height": 325
      },
      "poi_business_url": "https://www.wac.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10230906589697651864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-athletic-club",
      "poi_latitude": "47.6096207",
      "poi_longitude": "-122.3335738",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-622-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYtiabRqkFQRmLQhcVZ7-40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_18ca0fc8-971c-4f51-bd8b-0159f92ddd79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2310 5th Ave #3, Seattle, WA 98121, USA",
      "poi_short_description": "Group-based gym featuring strength-training workouts, plus cardio machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-fb86-73ed-8f19-5263ae03ee32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-fb86-73ed-8f19-5263ae03ee32",
        "storage_key": "property/6767906449166934/019d01ad-fb86-73ed-8f19-5263ae03ee32.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/seattle-washington-0580?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=9056574650186349697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "47.61633639999999",
      "poi_longitude": "-122.3432044",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-855-5089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4N9VkkVkFQRgTwqGqlqr30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_64414793-e39e-471d-a548-fcceb049755f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "CorePower Yoga - Belltown",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 5th Ave #101, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-fb0a-769d-8227-a64d2286e604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-fb0a-769d-8227-a64d2286e604",
        "storage_key": "property/6767906449166934/019d01ad-fb0a-769d-8227-a64d2286e604.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/wa/seattle/belltown",
      "poi_directions_map_url": "https://maps.google.com/?cid=16682432067331597472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---belltown",
      "poi_latitude": "47.6162109",
      "poi_longitude": "-122.3440055",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc2EiIxkVkFQRoKTi8pPng-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_250a2431-9a1b-4081-89ed-3aefa8030234",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "124 Denny Wy, Seattle, WA 98109, USA",
      "poi_short_description": "Chain Pilates studio offering reformer fusion classes in Queen Anne.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-fd08-72bc-a1e4-40dac2f1dc5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-fd08-72bc-a1e4-40dac2f1dc5c",
        "storage_key": "property/6767906449166934/019d01ad-fd08-72bc-a1e4-40dac2f1dc5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/queenanne/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10419071609321546614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "47.618793",
      "poi_longitude": "-122.354506",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-274-7374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwfBMQkUVkFQRduP3Em36l5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae736fac-72b4-4795-bb8f-a87d36e66887",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "UW Medicine Primary Care at Belltown",
      "poi_type": "Health and Wellness",
      "poi_address": "2505 2nd Ave Suite 200, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-fcf1-751a-916a-bd8a33c624cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-fcf1-751a-916a-bd8a33c624cc",
        "storage_key": "property/6767906449166934/019d01ad-fcf1-751a-916a-bd8a33c624cc.webp",
        "width": 782,
        "height": 368
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/primary-care-belltown?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNTYwNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5115407827321396952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uw-medicine-primary-care-at-belltown",
      "poi_latitude": "47.61533619999999",
      "poi_longitude": "-122.3484266",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-443-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31vhZk4VkFQR2J6-_FCU_UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_567e03e9-2bb4-4e73-9a5e-53003a64b92d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Olympic Sculpture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2901 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_long_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-e601-77c2-a6bc-73a06df6548b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-e601-77c2-a6bc-73a06df6548b",
        "storage_key": "property/6767906449166934/019d01ad-e601-77c2-a6bc-73a06df6548b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleartmuseum.org/visit/olympic-sculpture-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8934295156938678169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olympic-sculpture-park",
      "poi_latitude": "47.6166028",
      "poi_longitude": "-122.3553167",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc88dJ1AVkFQRmZ_S-xv-_Hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_897b00b2-7a5f-4bb2-a82a-591c601f2973",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Myrtle Edwards Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3130 Alaskan Way, Seattle, WA 98121, USA",
      "poi_short_description": "Waterfront recreation area with bike & pedestrian paths, plus an adjacent sculpture park.",
      "poi_long_description": "Waterfront recreation area with bike & pedestrian paths, plus an adjacent sculpture park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-02a0-74e8-8c81-d26316fced19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-02a0-74e8-8c81-d26316fced19",
        "storage_key": "property/6767906449166934/019d01ae-02a0-74e8-8c81-d26316fced19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/myrtle-edwards-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13640186970880608794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "myrtle-edwards-park",
      "poi_latitude": "47.619438",
      "poi_longitude": "-122.361817",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yjQRVwVkFQRGgpA_cetS70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_456e3325-732c-44db-8342-fbb01599c840",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Victor Steinbrueck Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1999 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Waterfront park adjacent to Pike Place Market featuring a large lawn plus benches & tables.",
      "poi_long_description": "Waterfront park adjacent to Pike Place Market featuring a large lawn plus benches & tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-055c-7547-92b5-8e71a6fe8eed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-055c-7547-92b5-8e71a6fe8eed",
        "storage_key": "property/6767906449166934/019d01ae-055c-7547-92b5-8e71a6fe8eed.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/victor-steinbrueck-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7524507683480633865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "victor-steinbrueck-park",
      "poi_latitude": "47.61015039999999",
      "poi_longitude": "-122.3438756",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fHMtLJqkFQRCYKPH99rbGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7233615a-c0dd-403e-8d72-2eede6c2d847",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Lake Union Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "860 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_long_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-03e4-760d-b59a-9248183115fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-03e4-760d-b59a-9248183115fb",
        "storage_key": "property/6767906449166934/019d01ae-03e4-760d-b59a-9248183115fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lake-union-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021986494381383037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-union-park",
      "poi_latitude": "47.6277112",
      "poi_longitude": "-122.3368686",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbpC3DsVkFQRfV3tymwamMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_adc22af2-1a59-4cc7-8c8e-628972f182f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Denny Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_long_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0543-7579-9a86-254143ee7cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0543-7579-9a86-254143ee7cea",
        "storage_key": "property/6767906449166934/019d01ae-0543-7579-9a86-254143ee7cea.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/denny-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17697390754654843374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denny-park",
      "poi_latitude": "47.619053",
      "poi_longitude": "-122.340936",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cLUtUkVkFQR7vF7ZiDDmfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7df7107e-cc8b-4b4a-8588-3d3b300f06a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Westlake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Centrally located shopping district sitting spot & town square with a play area & fountain.",
      "poi_long_description": "Centrally located shopping district sitting spot & town square with a play area & fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0844-751f-b8f2-94c8421665eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0844-751f-b8f2-94c8421665eb",
        "storage_key": "property/6767906449166934/019d01ae-0844-751f-b8f2-94c8421665eb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/westlake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16678514624800721591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-park",
      "poi_latitude": "47.6109571",
      "poi_longitude": "-122.3370146",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76iup7RqkFQRt4pnSK_8dec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_728296f4-c15b-4cc2-aefd-81bb21439447",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Bell Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "340 Bell St #98121, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0a10-73e3-8f3f-8fb5f74af1ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0a10-73e3-8f3f-8fb5f74af1ae",
        "storage_key": "property/6767906449166934/019d01ae-0a10-73e3-8f3f-8fb5f74af1ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/bell-street-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9589294599024961341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-street-park",
      "poi_latitude": "47.61531069999999",
      "poi_longitude": "-122.3440829",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5feGMEwVkFQRPWd0raEEFIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_94fc092b-2ae4-462b-b362-a23fbcb6aef2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Belltown Cottage Park & P-Patch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2512 Elliott Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Local park featuring 3 historic cottages surrounded by gardens, green space & a fountain.",
      "poi_long_description": "Local park featuring 3 historic cottages surrounded by gardens, green space & a fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0b00-719b-948d-21aad49719f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0b00-719b-948d-21aad49719f7",
        "storage_key": "property/6767906449166934/019d01ae-0b00-719b-948d-21aad49719f7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/belltown-cottage-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722673367583781954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belltown-cottage-park--p-patch",
      "poi_latitude": "47.6139351",
      "poi_longitude": "-122.3509091",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJybxr_FEVkFQRQnS3ydPeEug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_23c7f1ad-715a-435e-b957-7d9749fed269",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Waterfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1401 Alaskan Wy, Seattle, WA 98101, USA",
      "poi_short_description": "Public park with a boardwalk & a pair of sculptures, plus views of the skyline & ships in drydock.",
      "poi_long_description": "Public park with a boardwalk & a pair of sculptures, plus views of the skyline & ships in drydock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0b45-70be-b49f-7ea05bc860de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0b45-70be-b49f-7ea05bc860de",
        "storage_key": "property/6767906449166934/019d01ae-0b45-70be-b49f-7ea05bc860de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/waterfront-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313300392261664270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterfront-park",
      "poi_latitude": "47.60704",
      "poi_longitude": "-122.3418276",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7yqjK1qkFQRDj6HS3N-GiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_89a39f2a-42f7-4f5d-8491-48ebaef5d928",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Westlake Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4th Ave, Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_long_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-0e69-71ea-97f9-f496abbc1a37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-0e69-71ea-97f9-f496abbc1a37",
        "storage_key": "property/6767906449166934/019d01ae-0e69-71ea-97f9-f496abbc1a37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.seattlemonorail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14068683656837464517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120708",
      "poi_longitude": "-122.3369693",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWm2x7RqkFQRxQEkLz8BPsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_51d3cc71-a6b0-4487-89f5-1029bae19c8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "370 Thomas St, Seattle, WA 98109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-107d-76cd-b1dc-19c7726e4f98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-107d-76cd-b1dc-19c7726e4f98",
        "storage_key": "property/6767906449166934/019d01ae-107d-76cd-b1dc-19c7726e4f98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.seattlemonorail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13535058097728434004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-center",
      "poi_latitude": "47.6212828",
      "poi_longitude": "-122.3497545",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-905-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOWl1d0YVkFQRVK9gyaAv1rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_ad05d252-e986-47cc-8001-7608dbe577e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "McGraw Square",
      "poi_type": "Transportation & Transit",
      "poi_address": "531 Stewart St Westlake Ave &, Stewart St, Seattle, WA 98101, USA",
      "poi_short_description": "Small downtown pedestrian plaza with a memorial statue & occasional food vendors.",
      "poi_long_description": "Small downtown pedestrian plaza with a memorial statue & occasional food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-11f4-730b-93e6-ea8510f1bfcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-11f4-730b-93e6-ea8510f1bfcc",
        "storage_key": "property/6767906449166934/019d01ae-11f4-730b-93e6-ea8510f1bfcc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/mcgraw-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=4950524839590417307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgraw-square",
      "poi_latitude": "47.61301",
      "poi_longitude": "-122.3375436",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3282-751f-b85e-631d54b01b81",
        "storage_key": "property/6767906449166934/019d01ae-3282-751f-b85e-631d54b01b81.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSmIR0sVkFQRm9OI0xzMs0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_deb0ee5d-9fc9-40c0-b1d0-5d9eeaefa154",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Pioneer Square",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1206-749c-9573-e69f5a698c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1206-749c-9573-e69f5a698c7e",
        "storage_key": "property/6767906449166934/019d01ae-1206-749c-9573-e69f5a698c7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/pioneer-square-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=441076786367121759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-square",
      "poi_latitude": "47.603016",
      "poi_longitude": "-122.3314347",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5PmgbBqkFQRX0kVEgAFHwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_869bd1aa-cb2d-4a08-9f29-9d16561b7d95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle, Washington King Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "303 S Jackson St, Seattle, WA 98104, USA",
      "poi_short_description": "This working train station built in 1906 features a brick & granite facade & a 12-story clock tower.",
      "poi_long_description": "This working train station built in 1906 features a brick & granite facade & a 12-story clock tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-13fb-729b-9c2c-0c94414d152a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-13fb-729b-9c2c-0c94414d152a",
        "storage_key": "property/6767906449166934/019d01ae-13fb-729b-9c2c-0c94414d152a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/transportation/kingstreet.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505356831325706598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-washington-king-street-station",
      "poi_latitude": "47.5983889",
      "poi_longitude": "-122.3299086",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy_gXRbtqkFQRZlnYHuMXLtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_34ff2723-d0cf-4b4f-a235-88c957f83376",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Colman Dock",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Alaskan Wy, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1590-7698-abb8-e464a40b9208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1590-7698-abb8-e464a40b9208",
        "storage_key": "property/6767906449166934/019d01ae-1590-7698-abb8-e464a40b9208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wsdot.com/ferries/vesselwatch/terminaldetail.aspx?terminalid=7",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467170663738880714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colman-dock",
      "poi_latitude": "47.6028305",
      "poi_longitude": "-122.3378842",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-808-7977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGx2xvK9qkFQRyrK31V0A5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b105dc0-11ce-44a6-ac17-c368eb58440c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "West Seattle Water Taxi Pier",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seacrest Ferry Dock, Seattle, WA 98116, USA",
      "poi_short_description": "Scenic pier for a ferry ride across the bay to downtown, with skyline views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1778-72bb-9039-900442c81749.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1778-72bb-9039-900442c81749",
        "storage_key": "property/6767906449166934/019d01ae-1778-72bb-9039-900442c81749.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kingcounty.gov/depts/transportation/water-taxi/west-seattle.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2966229766925833175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-seattle-water-taxi-pier",
      "poi_latitude": "47.5896818",
      "poi_longitude": "-122.3800249",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-uid8hBkFQR19PN20EqKik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_fc77bb0d-9cd8-4816-8e9c-383fb18b98e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "3rd Ave & Pine St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98181, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-18e9-7503-b044-9d7f1ab6816c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-18e9-7503-b044-9d7f1ab6816c",
        "storage_key": "property/6767906449166934/019d01ae-18e9-7503-b044-9d7f1ab6816c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tripplanner.kingcounty.gov/hiwire?.a=iNextBusResults&StopId=430&StopName=3rd%20Ave%20@%20Pine%20St%20(SB)",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152032647595636408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3rd-ave--pine-st",
      "poi_latitude": "47.6112131",
      "poi_longitude": "-122.3390069",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2-bQ7NqkFQRuDa3FDSNAn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_4f8acd7f-58c9-4e2f-aecf-e8849e0f2c77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle–Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-197a-7193-842b-8c6f1faaea85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-197a-7193-842b-8c6f1faaea85",
        "storage_key": "property/6767906449166934/019d01ae-197a-7193-842b-8c6f1faaea85.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattletacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 206-787-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3211-744b-a6fd-ae8c4148ca0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3211-744b-a6fd-ae8c4148ca0d",
        "storage_key": "property/6767906449166934/019d01ae-3211-744b-a6fd-ae8c4148ca0d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_07da6c3b-d299-4b5c-b692-f5a2bf16a407",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Amazon - Day 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2121 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1a7a-72dc-b7c2-c4b1890c19e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1a7a-72dc-b7c2-c4b1890c19e0",
        "storage_key": "property/6767906449166934/019d01ae-1a7a-72dc-b7c2-c4b1890c19e0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2287641477610251425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon---day-1",
      "poi_latitude": "47.6161585",
      "poi_longitude": "-122.33991",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 888-280-4331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46lmAjcVkFQRoaRors1Vvx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_236a9eeb-a3c5-4f8a-9212-b167e5ec725c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Fred Hutch Cancer Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 Fairview Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1d32-7003-b5e0-7a2507f5863c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1d32-7003-b5e0-7a2507f5863c",
        "storage_key": "property/6767906449166934/019d01ae-1d32-7003-b5e0-7a2507f5863c.webp",
        "width": 1280,
        "height": 822
      },
      "poi_business_url": "https://www.fredhutch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13660788334964817360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-hutch-cancer-center",
      "poi_latitude": "47.62754340000001",
      "poi_longitude": "-122.331226",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-667-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT5V0iQVkFQR0L1g2ZzelL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c1388200-da9d-49b5-a358-fbfae0314d79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Corporate Offices - Nordstrom 864",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://shop.nordstrom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14231405951415434743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-offices---nordstrom-864",
      "poi_latitude": "47.6078279",
      "poi_longitude": "-122.338124",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-282-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e09-75e9-b314-ebf05a752643",
        "storage_key": "property/6767906449166934/019d01ae-2e09-75e9-b314-ebf05a752643.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8kQNbJqkFQR9z1_xE8cgMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1d6e7b7d-d385-4efb-8953-fdde609d753e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "US District Court",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Stewart St, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1fb5-73e9-ab78-103cf0504d19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1fb5-73e9-ab78-103cf0504d19",
        "storage_key": "property/6767906449166934/019d01ae-1fb5-73e9-ab78-103cf0504d19.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wawd.uscourts.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17608717711183102259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-district-court",
      "poi_latitude": "47.6149601",
      "poi_longitude": "-122.3365444",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-370-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-35d8-705f-971b-2ff2ad059a95",
        "storage_key": "property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQ044UoVkFQRM8EynXa7XvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_cced12e1-3654-46a6-9deb-8b9b531cf540",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "King County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 3rd Ave, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-1eea-7165-ae64-ebe982fa6a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-1eea-7165-ae64-ebe982fa6a83",
        "storage_key": "property/6767906449166934/019d01ae-1eea-7165-ae64-ebe982fa6a83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kingcounty.gov/about/contact-us/locations/Courthouse.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15425142603987560826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-county-courthouse",
      "poi_latitude": "47.6027783",
      "poi_longitude": "-122.3304087",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-477-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-35d8-705f-971b-2ff2ad059a95",
        "storage_key": "property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDRNoY7pqkFQReils8HgdEdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_54aa1181-b955-465c-bffb-4257d2b48917",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Seattle City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-202e-76ac-a6ef-edd88a0ee732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-202e-76ac-a6ef-edd88a0ee732",
        "storage_key": "property/6767906449166934/019d01ae-202e-76ac-a6ef-edd88a0ee732.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12499598841282423791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-city-hall",
      "poi_latitude": "47.6038962",
      "poi_longitude": "-122.3298441",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-35d8-705f-971b-2ff2ad059a95",
        "storage_key": "property/6767906449166934/019d01ae-35d8-705f-971b-2ff2ad059a95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVY3XoLBqkFQR7-uFoet-d60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1216a34a-2404-4bfc-8f2e-fd2f1b04c3ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-f097-71bf-aea1-b33229ec136e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-f097-71bf-aea1-b33229ec136e",
        "storage_key": "property/6767906449166934/019d01ad-f097-71bf-aea1-b33229ec136e.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3215-72db-9df5-0e74393eed44",
        "storage_key": "property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_755ff74c-dde8-4293-8d36-caaabf289f38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Swedish Hospital - First Hill Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "747 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-22aa-7470-89e9-c25e0492b599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-22aa-7470-89e9-c25e0492b599",
        "storage_key": "property/6767906449166934/019d01ae-22aa-7470-89e9-c25e0492b599.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.swedish.org/locations/first-hill-campus?Is=location&y_source=1_OTU3NjkyMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5633867081434861685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swedish-hospital---first-hill-campus",
      "poi_latitude": "47.608469",
      "poi_longitude": "-122.321481",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-386-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3215-72db-9df5-0e74393eed44",
        "storage_key": "property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9fNUchqkFQRdRCx1EKEL04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ed734c2d-62c1-450e-b1b8-0e55da32fc20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "Virginia Mason Hospital: Seattle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "925 Seneca St, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2494-72c4-ad67-545e1bfaa218.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-2494-72c4-ad67-545e1bfaa218",
        "storage_key": "property/6767906449166934/019d01ae-2494-72c4-ad67-545e1bfaa218.webp",
        "width": 1280,
        "height": 1078
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/virginia-mason-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7530099961694741651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-mason-hospital-seattle",
      "poi_latitude": "47.6100279",
      "poi_longitude": "-122.3274811",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-223-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-3215-72db-9df5-0e74393eed44",
        "storage_key": "property/6767906449166934/019d01ae-3215-72db-9df5-0e74393eed44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgTtB_LVqkFQRk2T_2wRKgGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3905c338-177d-4806-81da-87021a1e1489",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2549-716a-9cc3-74880a3648b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-2549-716a-9cc3-74880a3648b8",
        "storage_key": "property/6767906449166934/019d01ae-2549-716a-9cc3-74880a3648b8.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.65671709999999",
      "poi_longitude": "-122.3066181",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ae-2e0a-7579-ac4e-5d7c125e5e6a",
        "storage_key": "property/6767906449166934/019d01ae-2e0a-7579-ac4e-5d7c125e5e6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a497b1d50f0f6d8ddc492721",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ca9dcf47134eab34c473f13f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_99aa76cb8ddedb99e98635ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_32ba64e01c1e92a2d9d7c2fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_16e9303e9bebb214940e5f9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_29af0aefb21fad6a1beda51e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ee62b7536463ba6dd62ddee2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b753b466f3529696cb77e87d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "rating": "5",
      "name": "Aseem Raina",
      "text": "We recently toured several apartments and are now in the process of signing a lease here. The entire experience has been incredibly smooth, thanks in large part to Chloe from the leasing team. She coordinated multiple tours for us, guided us through every detail with care, and addressed our concerns with full transparency, which we truly appreciated. Communication was consistently prompt, and overall, we couldn’t be happier with how everything went!",
      "date": "2025-11-11",
      "title": "false"
    },
    {
      "id": "ec_42c89d93dc634258a49a6162",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "rating": "5",
      "name": "Mehakpreet Singh",
      "text": "My kitchen and bathroom lights were notworking. I raised a service request for the bulb replacement. The service was very quick. Sam, came by to fix the lights in no time. It was better than the expectations and he also guided me how to change the bulbs not included in the service. Keep up the good work.",
      "date": "2025-09-21",
      "title": "false"
    },
    {
      "id": "ec_8169552090bc8499a5f596b9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "rating": "5",
      "name": "Nandini Gupta",
      "text": "Via6 is in an amazing spot, with everything downtown just a short walk away. The concierge team is warm and welcoming, especially Insa, who goes above and beyond to help residents. My apartment is comfortable, and gets great natural light. The building is generally clean and well-kept. I have experienced more maintenance issues than I would have liked, which can be frustrating at times, but the positives of the location and staff still make it a good place to live overall.",
      "date": "2025-08-10",
      "title": "false"
    },
    {
      "id": "ec_861504b12494d6e67a86a42c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "rating": "5",
      "name": "Sahara Mathur",
      "text": "After reading the reviews for via I was really hesitant to tour but now that I have I question the accuracy and if these reviews are putting the full story. We toured with Chloe and even though my boyfriend and I aren’t moving until the end of the year she still took the time to show us the community and answer my many questions. She was very kind to us and made us feel already at home. Not to mention the scale of via. Such an impressive building. We definitely will be leasing at Via in December.",
      "date": "2025-08-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6b8439ef-4472-465b-abbb-4614b2f18155",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bae-85b9-7078-8507-08f98e2ce8a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bae-85b9-7078-8507-08f98e2ce8a7",
        "storage_key": "property/6767906449166934/019e3bae-85b9-7078-8507-08f98e2ce8a7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Amenity | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Yq25sPstUz1"
    },
    {
      "id": "custom_6d54715c-bec4-42ba-a151-151977b3cc66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bae-f547-767f-a0da-20204818d823.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bae-f547-767f-a0da-20204818d823",
        "storage_key": "property/6767906449166934/019e3bae-f547-767f-a0da-20204818d823.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": " Amenity | Strength Studio",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=J8XE1fu7LGf"
    },
    {
      "id": "custom_c6900ed1-6506-49c4-84bd-61bed1a7aa2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Amenity | Guest Suite",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FuVpC8BfaKK"
    },
    {
      "id": "custom_45d7b194-75fc-4671-b11a-db13169fcf87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a0f3ac-aad2-7168-a771-6b0b0ea35d7b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0f3ac-aad2-7168-a771-6b0b0ea35d7b",
        "storage_key": "property/6767906449166934/01a0f3ac-aad2-7168-a771-6b0b0ea35d7b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Amenity | Chef's Kitchen",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=okpdu7mUJjv"
    },
    {
      "id": "custom_a3933e34-b2e8-4275-af51-55e024d01049",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3baf-4b3d-734c-82d8-3efaab201299.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3baf-4b3d-734c-82d8-3efaab201299",
        "storage_key": "property/6767906449166934/019e3baf-4b3d-734c-82d8-3efaab201299.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "0 Bed / 1 Bath | StuD | North Tower, 24th Floor | Penthouse | 501 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nDYJG6jiffR"
    },
    {
      "id": "custom_85e629b0-56a2-4458-87ff-e845dc96ea53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bb0-2d99-77bd-8460-136ab58d2350.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bb0-2d99-77bd-8460-136ab58d2350",
        "storage_key": "property/6767906449166934/019e3bb0-2d99-77bd-8460-136ab58d2350.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bed / 1 Bath | 11B | South Tower, 23rd Floor | Penthouse | 680 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rdJoGeGphFn"
    },
    {
      "id": "custom_33562ec9-f7b5-4194-ba5b-05465c26bcfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a0f3ad-6fa9-7346-bb2a-9af1629c2f73.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0f3ad-6fa9-7346-bb2a-9af1629c2f73",
        "storage_key": "property/6767906449166934/01a0f3ad-6fa9-7346-bb2a-9af1629c2f73.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bed / 1 Bath | 11A | South Tower, 22nd Floor | 645 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZEo4MaAY4cC"
    },
    {
      "id": "custom_82cd12ee-edbb-48b7-a895-60fb4aed19bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3baf-ba41-70dd-9c35-023944bdbd2f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3baf-ba41-70dd-9c35-023944bdbd2f",
        "storage_key": "property/6767906449166934/019e3baf-ba41-70dd-9c35-023944bdbd2f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bed / 1 Bath | 11B | South Tower, 24th Floor | 655 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NXapgbxJZUT"
    },
    {
      "id": "custom_9d0263c1-ba54-41fe-9252-1b375bf58b4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01af-7e5b-75fd-b8a5-45e2fa352ba8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with large window and city view",
        "public_id": "019d01af-7e5b-75fd-b8a5-45e2fa352ba8",
        "storage_key": "property/6767906449166934/019d01af-7e5b-75fd-b8a5-45e2fa352ba8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bed / 1 Bath | 11B | South Tower, 23rd Floor | Penthouse | 680 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Neq23DrtC8S"
    },
    {
      "id": "custom_2e735711-b481-4abd-a505-060c6aee52a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01af-84e0-70df-92e6-eb18b694082e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an empty apartment living room with large windows and city views.",
        "public_id": "019d01af-84e0-70df-92e6-eb18b694082e",
        "storage_key": "property/6767906449166934/019d01af-84e0-70df-92e6-eb18b694082e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bed / 2 Bath | 21A | North Tower, 18th Floor | 834 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Q2W6aUBPwF1"
    },
    {
      "id": "custom_d2825679-8f0e-4f05-a401-f348f7c5bdf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bb1-31f2-769e-9dc5-bd1ca155ecd6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bb1-31f2-769e-9dc5-bd1ca155ecd6",
        "storage_key": "property/6767906449166934/019e3bb1-31f2-769e-9dc5-bd1ca155ecd6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bed / 2 Bath | 21A | South Tower, 12th Floor | 834 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XLHXG7ArKRS"
    },
    {
      "id": "custom_1a3dd3fe-d044-44d0-994c-1b7868b39d2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bb0-e037-7418-bedf-b2105159c3ea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bb0-e037-7418-bedf-b2105159c3ea",
        "storage_key": "property/6767906449166934/019e3bb0-e037-7418-bedf-b2105159c3ea.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bed / 2 Bath | 21D | South Tower, 23rd Floor | Penthouse | 853 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=k3tyVmgn3mj"
    },
    {
      "id": "custom_7fe1e9fc-2b97-4781-9737-2eac0e60c9a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e3bb1-7dda-74fa-bb02-868725e86e01.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bb1-7dda-74fa-bb02-868725e86e01",
        "storage_key": "property/6767906449166934/019e3bb1-7dda-74fa-bb02-868725e86e01.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bed / 2 Bath | 22L | South Tower, 5th Floor | 1,027 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mbrYksBrHv5"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_3b43a728736d1a1124a689b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "e64beea0bd901760",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_63c4a642a567eeb5dc808726",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "ee67c661f8c68f1a",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b25256f7e1574570f126cd52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "775d5b715d7880ac",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f7e2a8af2bed5cd618abac5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "66fe24ba1de98fc8",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 2500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d1f4a605f6591869dba46318",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "efc83f2df1c94439",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d6c8c8f40681bb99b68b22fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "dabd41c9db1c6d01",
      "name": "Sewer Charge",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a70db119d579fcf2249dc869",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "3739d8257125b796",
      "name": "Garbage Charge",
      "description": "Garbage Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4c2c49951fd4b2a09da0e45a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "fd132f56d49bc82b",
      "name": "Pest Control",
      "description": "Pest Control Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_01bdf1212b3a0b18a5016c3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "63bd9c103d91e136",
      "name": "Sewer Capacity Charge",
      "description": "Sewer Capacity Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb2d4171e7c22877100435a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "1b8634f35ee13427",
      "name": "Stormwater Charge",
      "description": "Stormwater Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ccac76ddcb14c43fa5a773a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "cda2af7991673cf0",
      "name": "Water Service Charge",
      "description": "Base Water Service Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwaterb",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6440bddf7417fe0c9217887a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "6e1e7e8b12006430",
      "name": "Common Area Gas",
      "description": "Common Are Gas Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_17ab4dae2e83814bf54703ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "10821cb81442dd7a",
      "name": "Hot Water Gas Charge",
      "description": "Domestic Hot Water Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3be607298e1018372ef60cf6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "ff29537efdd06585",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Admin Fee",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_fa121835b8134511bbcf3282",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "yardi",
      "external_id": "2701909",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 50,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "019aa6f3-c258-769a-bc36-ea8ff445e736",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "weidner-via6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "dog-park-apartments-downtown-seattle",
      "search_query": "apartments with dog park in downtown Seattle",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Downtown Seattle",
      "h2_subtitle": "Discover pet-friendly living at Via6 with our dedicated dog park. Located in vibrant downtown Seattle, enjoy urban life with your four-legged friend.",
      "page_copy": "Welcome to Via6, the pet-friendly haven in the heart of downtown Seattle. Our community offers more than just upscale living; it’s an oasis for pet owners. With our dedicated dog park, your furry companion can frolic and play to their heart's content. At Via6, we understand the bond between you and your pet, and our amenities reflect that commitment. \n\nChoose from our spacious one- and two-bedroom apartments, each featuring modern comforts like air conditioning and private balconies. Beyond the fantastic dog park, residents enjoy an array of amenities, including a state-of-the-art fitness center and a welcoming clubhouse. Discover the convenience and joy of living in a community that values both you and your pets. Contact us today to learn more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park - Via6 Seattle",
      "seo_description": "Explore Via6, featuring a dog park, in downtown Seattle. Your pet-friendly apartment awaits! Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-seattle-wa",
      "search_query": "fitness center apartments in Seattle WA",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Seattle, WA",
      "h2_subtitle": "Experience top-notch fitness living at Via6 in Seattle, WA. Our residents enjoy a state-of-the-art fitness center along with modern apartment comforts.",
      "page_copy": "Discover Via6, a premier apartment community in Seattle, WA, offering residents a perfect blend of luxury and fitness. At the heart of our community is a state-of-the-art fitness center that's equipped with the latest cardio and strength-training machines. Whether you're a fitness enthusiast or just starting your wellness journey, our facilities cater to all levels and help you maintain an active lifestyle.\n\nConveniently located in downtown Seattle, Via6 provides modern one- and two-bedroom floor plans adorned with top-tier features, including walk-in closets and private balconies. Alongside our excellent fitness amenities, enjoy access to our clubhouse, lounge, and air-conditioned apartments, making Via6 the ideal home base for a balanced life in the city. Schedule a tour today and take the first step towards your new active lifestyle!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments - Via6 Seattle",
      "seo_description": "Live at Via6 in Seattle, WA. State-of-the-art fitness center and modern amenities await! Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-downtown-seattle",
      "search_query": "air conditioned apartments in Downtown Seattle",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Downtown Seattle",
      "h2_subtitle": "Enjoy the comfort of air-conditioned living at Via6 in downtown Seattle. Experience modern amenities in our spacious apartment homes.",
      "page_copy": "Welcome to Via6, where air-conditioned comfort meets urban living right in the heart of downtown Seattle. Our one- and two-bedroom apartments offer a cool retreat from the bustling city life, ensuring you enjoy every season indoors. Air conditioning in each apartment guarantees that you maintain a perfect temperature all year round, making Via6 the ideal choice for comfort lovers.\n\nApart from providing cooling relief, Via6 boasts an array of amenities designed to enhance your lifestyle. Enjoy a fully-equipped fitness center, a vibrant clubhouse, and a serene dog park, all set in a pet-friendly community. Conveniences like private balconies and modern interiors make living at Via6 a pleasure. Discover a new level of comfort and style in our air-conditioned apartments—schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Seattle - Via6",
      "seo_description": "Find comfort in Via6's air-conditioned apartments in downtown Seattle. Modern amenities and excellent location. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "washer-dryer-in-unit-apartments-king-county",
      "search_query": "washer and dryer in unit apartments King County",
      "category": "Amenity",
      "h1_title": "In-Unit Washer and Dryer Apartments in King County",
      "h2_subtitle": "Discover the convenience of in-unit washers and dryers at Via6, situated in vibrant Seattle, WA, within King County.",
      "page_copy": "Experience the height of convenience at Via6, where every apartment comes equipped with a washer and dryer in unit. Located in King County, our community ensures that laundry day is a breeze, allowing you more free time to enjoy the vibrant surroundings of downtown Seattle. Forget about quarters and shared facilities; at Via6, we prioritize your convenience and comfort.\n\nIn addition to these essential amenities, Via6 offers beautifully designed one- and two-bedroom floor plans with modern interiors and private balconies. Our pet-friendly facilities include a fantastic dog park, a cutting-edge fitness center, and a welcoming clubhouse, all contributing to a lifestyle that’s as comfortable as it is luxurious. Join us at Via6 and embrace apartment living that encompasses both style and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer & Dryer Apartments - Via6 King County",
      "seo_description": "Enjoy in-unit washer and dryer convenience at Via6, King County. Modern amenities in Seattle! Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "luxury-apartments-walk-in-closets-seattle",
      "search_query": "luxury apartments with walk in closets Seattle",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Walk-In Closets Seattle",
      "h2_subtitle": "Discover luxurious living with spacious walk-in closets at Via6 in Seattle. Our modern apartments blend style with comfort.",
      "page_copy": "Welcome to Via6, where luxury meets practicality in the heart of Seattle. Our upscale one- and two-bedroom apartments offer spacious walk-in closets, providing ample storage and organization for your wardrobe. This feature, coupled with contemporary design elements, elevates your living experience in this vibrant city.\n\nLocated in bustling downtown Seattle, Via6 is surrounded by a host of amenities that enhance urban living. Enjoy air-conditioned comfort, a state-of-the-art fitness center, and a stylish clubhouse, all within a pet-friendly community. With private balconies offering stunning views, Via6 combines modern elegance with functional living spaces. Experience the perfect blend of luxury and convenience—contact us today for a tour of Via6.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Walk-In Closets - Via6",
      "seo_description": "Live in luxury at Via6 in Seattle. Spacious walk-in closets and top amenities await. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-downtown-seattle",
      "search_query": "1 bedroom apartments downtown seattle",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Downtown Seattle",
      "h2_subtitle": "Explore stylish 1 bedroom apartments at Via6, located in the heart of downtown Seattle. Experience urban living with exceptional amenities.",
      "page_copy": "Discover the perfect urban retreat at Via6 with our delightful 1 bedroom apartments, set in the lively hub of downtown Seattle. Offering a blend of modern architecture and thoughtful amenities, these apartments are designed to fit a dynamic lifestyle while providing all the comforts of home. Each unit boasts air conditioning and a private balcony, ensuring you have a personal oasis amidst the city buzz.\n\nBeyond your apartment, enjoy the vibrant community spaces and amenities that Via6 offers. Work out in our up-to-date fitness center or unwind in the clubhouse. Our pet-friendly environment also features a dog park, ideal for pet owners looking to live in the city. With cable-ready units, you have everything at your fingertips. Discover these exceptional 1 bedroom apartments and embrace the Seattle lifestyle—schedule your tour today at Via6.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Downtown Seattle - Via6",
      "seo_description": "Explore modern 1 bedroom apartments in downtown Seattle at Via6. Enjoy top amenities and urban comfort. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-king-county-wa",
      "search_query": "2 bedroom apartments king county wa",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in King County, WA",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Via6, located in vibrant King County, WA. Enjoy modern amenities and a prime Seattle location.",
      "page_copy": "Find your perfect home at Via6, where our expansive 2 bedroom apartments provide an ideal blend of comfort and convenience in King County, WA. Each apartment offers ample living space, including generous walk-in closets and private balconies, perfect for enjoying the Seattle skyline. Experience the convenience of having a washer and dryer right in your home, making laundry chores a breeze.\n\nVia6 is nestled in the energetic neighborhood of downtown Seattle, providing easy access to all the city's attractions. Our community features top-notch amenities like a dog park, fitness center, and a modern clubhouse. These elements create a relaxed yet vibrant lifestyle, perfect for those who appreciate both function and style. Explore our 2 bedroom apartments today and see why Via6 is the place to call home in King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in King County, WA - Via6",
      "seo_description": "Explore spacious 2 bedroom apartments at Via6 in King County, WA. Enjoy top amenities and prime Seattle location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-lowell-elementary-school-seattle",
      "search_query": "apartments near lowell elementary school seattle",
      "category": "School",
      "h1_title": "Apartments Near Lowell Elementary School Seattle",
      "h2_subtitle": "Find convenient living near Lowell Elementary School at Via6. Our centrally-located apartments in Seattle offer exceptional amenities and easy access to education.",
      "page_copy": "Discover family-friendly living at Via6, ideally situated near Lowell Elementary School in the heart of Seattle. This prime location offers the convenience of being close to quality education while enjoying all the benefits of modern city living. Our spacious one- and two-bedroom apartments are designed to cater to your family's needs, featuring amenities that combine comfort with style.\n\nAt Via6, enjoy air-conditioned units, a state-of-the-art fitness center, and a cozy clubhouse that provides the perfect setting for relaxation and socializing. Our community is also equipped with a dog park, making it perfect for families with pets. Living near Lowell Elementary School means you’re part of a vibrant neighborhood with easy access to Seattle's best attractions and services. Visit Via6 and see how living near excellent schools can enhance your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lowell Elementary School - Via6",
      "seo_description": "Live near Lowell Elementary School at Via6 in Seattle. Enjoy modern amenities and a prime location. Tour our family-friendly community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-close-to-edmond-s-meany-middle-school",
      "search_query": "apartments close to edmond s meany middle school king county",
      "category": "School",
      "h1_title": "Apartments Near Edmond S Meany Middle School",
      "h2_subtitle": "Choose Via6 for convenient apartment living close to Edmond S Meany Middle School. Enjoy a vibrant community in King County, WA.",
      "page_copy": "Located in the energetic backdrop of Seattle, Via6 offers a stellar option for those seeking apartments close to Edmond S Meany Middle School in King County. Perfectly situated for families, our community features spacious one- and two-bedroom layouts that are both stylish and functional. Each apartment is equipped with modern essentials such as air conditioning and cable readiness, ensuring comfort throughout.\n\nLiving at Via6 means experiencing amenities that enhance your daily life, including a fully equipped fitness center and a welcoming clubhouse. Our community also caters to pet owners with a designated dog park area. Proximity to Edmond S Meany Middle School puts educational opportunities within easy reach, making Via6 an ideal choice for families who prioritize both location and lifestyle. Explore our beautiful community and find the perfect home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Edmond S Meany Middle School - Via6",
      "seo_description": "Live close to Edmond S Meany Middle School at Via6. Enjoy superior amenities and a prime King County location. Schedule a tour of our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "rentals-near-garfield-high-school-wa",
      "search_query": "rentals near garfield high school wa",
      "category": "School",
      "h1_title": "Rentals Near Garfield High School WA",
      "h2_subtitle": "Discover prime rentals near Garfield High School at Via6. Located in Seattle, WA, enjoy modern living with fantastic amenities.",
      "page_copy": "Via6 offers the perfect blend of convenience and style for those seeking rentals near Garfield High School in Seattle, WA. Our community is designed to provide a fulfilling urban living experience, featuring modern one- and two-bedroom apartments that cater to a variety of lifestyles. Enjoy the comfort of air conditioning, spacious walk-in closets, and private balconies that offer stunning views of the city.\n\nLiving at Via6 means unmatched access to Seattle's vibrant downtown while being just a short distance from Garfield High School. Residents can take advantage of excellent amenities, including a state-of-the-art fitness center, relaxing clubhouse, and a pet-friendly environment with a dog park. Our rentals offer the ideal combination of location and luxury, making Via6 the premier choice for those seeking a dynamic community in close proximity to quality education.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Garfield High School - Via6",
      "seo_description": "Find rentals near Garfield High School in Seattle, WA at Via6. Enjoy great amenities and easy city access. Visit our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-central-college-downtown",
      "search_query": "apartments near seattle central college downtown seattle",
      "category": "School",
      "h1_title": "Apartments Near Seattle Central College",
      "h2_subtitle": "Explore modern apartments near Seattle Central College at Via6. Enjoy urban living in the heart of Downtown Seattle.",
      "page_copy": "Situated in the vibrant and dynamic center of Downtown Seattle, Via6 offers contemporary apartments just moments away from Seattle Central College. Ideal for students and professionals alike, our community provides a convenient lifestyle with proximity to educational opportunities and cultural experiences. Choose from a selection of spacious one- and two-bedroom apartments, each featuring modern amenities designed for comfort and style.\n\nAt Via6, residents enjoy a host of exceptional facilities, including a fully equipped fitness center, a welcoming clubhouse perfect for social gatherings, and private balconies for those tranquil moments at home. Being near Seattle Central College means you're at the heart of Seattle's vibrant energy, with easy access to dining, shopping, and entertainment. Experience downtown living at its best by making Via6 your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Central College - Via6",
      "seo_description": "Discover apartments near Seattle Central College at Via6. Enjoy fantastic amenities in downtown Seattle. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "housing-near-seattle-university-98121",
      "search_query": "housing near seattle university 98121",
      "category": "School",
      "h1_title": "Housing Near Seattle University 98121",
      "h2_subtitle": "Find ideal housing near Seattle University at Via6. Located in the vibrant 98121 area, enjoy modern amenities and convenience.",
      "page_copy": "Via6 presents an excellent housing opportunity for those looking to stay near Seattle University, located in the bustling 98121 zip code. Our apartments blend contemporary design with convenience, making them perfect for students, faculty, and anyone seeking proximity to the university. Choose spacious one- and two-bedroom options that come with features designed to enhance your living experience, such as air conditioning and walk-in closets.\n\nThe vibrant community at Via6 offers more than just a place to stay. Enjoy access to a top-notch fitness center, a relaxing clubhouse, and other premium amenities that make life enjoyable and hassle-free. With Seattle University just a short distance away, you're perfectly positioned to balance academic, professional, and social life. Dive into the unique lifestyle that Downtown Seattle offers by choosing Via6 as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Seattle University - Via6",
      "seo_description": "Live near Seattle University in the 98121 area at Via6. Discover comfortable housing with top amenities. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-virginia-mason-medical-center",
      "search_query": "apartments near virginia mason medical center seattle",
      "category": "Hospital",
      "h1_title": "Apartments Near Virginia Mason Medical Center",
      "h2_subtitle": "Discover convenient apartments near Virginia Mason Medical Center at Via6. Enjoy living in vibrant Downtown Seattle.",
      "page_copy": "Nestled in the heart of vibrant Downtown Seattle, Via6 provides an exceptional living experience just moments from Virginia Mason Medical Center. Our apartments offer a perfect blend of comfort and accessibility, ideal for healthcare professionals, patients, and anyone seeking proximity to medical facilities. Choose from our spacious and elegantly designed one- and two-bedroom floor plans, each equipped with modern amenities like air conditioning and private balconies.\n\nVia6 offers much more than just a place to live; it's a community equipped with amenities that enhance your lifestyle. Enjoy the convenience of a state-of-the-art fitness center, a comfortable lounge, and the camaraderie of a welcoming clubhouse. Located near Virginia Mason Medical Center, our apartments offer easy access to healthcare and the lively downtown scene, making Via6 an unbeatable choice for those seeking urban living with convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Virginia Mason Medical Center",
      "seo_description": "Find modern apartments near Virginia Mason Medical Center in Seattle a Via6. Enjoy top amenities and downtown accessibility. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartment-living-by-harborview-medical-center",
      "search_query": "apartment living by harborview medical center downtown seattle",
      "category": "Hospital",
      "h1_title": "Apartment Living by Harborview Medical Center",
      "h2_subtitle": "Experience apartment living by Harborview Medical Center at Via6. Enjoy modern comforts in the heart of Downtown Seattle.",
      "page_copy": "Via6 offers an unmatched apartment living experience right by Harborview Medical Center in the bustling Downtown Seattle. Our community provides the perfect setting for healthcare professionals, families, and individuals needing easy access to medical facilities. Choose from our range of spacious one- and two-bedroom apartments, featuring modern designs and sought-after amenities such as air conditioning and private balconies.\n\nLiving at Via6 means more than a home; it's a living community thriving in the heart of the city. Residents enjoy exclusive access to a fully equipped fitness center, a convenient lounge, and a lively clubhouse. Proximity to Harborview Medical Center ensures that healthcare is always within reach, while Downtown Seattle's vibrant dining and shopping scene awaits your exploration. Let Via6 be your gateway to convenient and modern urban living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living by Harborview Medical Center",
      "seo_description": "Enjoy apartment living near Harborview Medical Center at Via6 in Downtown Seattle. Modern amenities and city life await. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-olympic-sculpture-park-seattle",
      "search_query": "apartments near Olympic Sculpture Park Seattle",
      "category": "Park",
      "h1_title": "Apartments Near Olympic Sculpture Park",
      "h2_subtitle": "Explore apartments near Olympic Sculpture Park at Via6. Enjoy art, nature, and modern living in Downtown Seattle.",
      "page_copy": "If living near art and nature is on your wishlist, Via6 offers the perfect solution with its proximity to Olympic Sculpture Park in Seattle. Our community provides residents an ideal blend of urban living steps away from this iconic cultural landmark. Choose from meticulously designed one- and two-bedroom apartments featuring modern amenities such as walk-in closets and private balconies.\n\nLiving at Via6 not only immerses you in art and culture but also offers a welcoming community rich in amenities. Residents can enjoy a state-of-the-art fitness center, a relaxing clubhouse, and a dedicated dog park. The nearby Olympic Sculpture Park offers an inspiring mix of contemporary art and breathtaking views of the Puget Sound, making Via6 a prime choice for those desiring urban convenience with a touch of nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Olympic Sculpture Park - Via6",
      "seo_description": "Discover lively apartment living near Olympic Sculpture Park at Via6 in Seattle. Enjoy art, nature, and top amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-close-to-myrtle-edwards-park",
      "search_query": "apartments close to Myrtle Edwards Park Downtown Seattle",
      "category": "Park",
      "h1_title": "Apartments Close to Myrtle Edwards Park",
      "h2_subtitle": "Find apartments close to Myrtle Edwards Park at Via6. Enjoy a balance of nature and city life in Downtown Seattle.",
      "page_copy": "Experience the best of both worlds at Via6, where you'll find apartments close to Myrtle Edwards Park in the heart of Downtown Seattle. This vibrant community provides an ideal living space for those who enjoy the tranquility of nature along with the convenience of city life. Our stylish one- and two-bedroom apartments include features like air conditioning, walk-in closets, and private balconies.\n\nAt Via6, you are part of a welcoming community with premium amenities designed to enhance your lifestyle. Enjoy the use of a modern fitness center, a welcoming clubhouse, and a pet-friendly environment complete with a dog park. Living close to Myrtle Edwards Park means easy access to walking trails and stunning views of the waterfront, making Via6 the perfect choice for enjoying the beauty of Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Myrtle Edwards Park - Via6",
      "seo_description": "Live near Myrtle Edwards Park at Via6 in Downtown Seattle. Enjoy modern amenities and proximity to nature. Visit us to find your new home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "seattle-apartments-near-victor-steinbrueck-park",
      "search_query": "Seattle apartments near Victor Steinbrueck Park",
      "category": "Park",
      "h1_title": "Seattle Apartments Near Victor Steinbrueck Park",
      "h2_subtitle": "Discover Seattle apartments near Victor Steinbrueck Park at Via6. Enjoy urban living close to iconic Pike Place Market.",
      "page_copy": "Embrace the vibrant city life with Seattle apartments near Victor Steinbrueck Park, right here at Via6. Located in the urban heart of the city, our community offers unparalleled access to one of Seattle’s most iconic parks and the famous Pike Place Market. Choose from our spacious one- and two-bedroom units featuring modern amenities like air conditioning and cable readiness, perfect for the contemporary resident.\n\nLiving at Via6 means immersing yourself in all that Downtown Seattle has to offer. Enjoy exclusive amenities such as a high-tech fitness center, a cozy clubhouse, and designated spaces for pet lovers. Being near Victor Steinbrueck Park allows residents to enjoy leisurely park visits, all while being steps away from the bustling market and Seattle’s lively cultural scene. Let Via6 be the starting point of your exciting Seattle adventure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle Apartments Near Victor Steinbrueck Park",
      "seo_description": "Experience urban living at Via6, with apartments near Victor Steinbrueck Park. Enjoy proximity to Pike Place Market and top amenities. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "downtown-seattle-apartments-near-lake-union-park",
      "search_query": "Downtown Seattle apartments near Lake Union Park",
      "category": "Park",
      "h1_title": "Downtown Seattle Apartments Near Lake Union Park",
      "h2_subtitle": "Explore Via6's Downtown Seattle apartments near Lake Union Park. Enjoy city conveniences with a touch of nature nearby.",
      "page_copy": "Via6 offers the perfect location for those seeking Downtown Seattle apartments near Lake Union Park. Our community combines the excitement of city life with the tranquility of nearby green spaces. Enjoy expansive one- and two-bedroom apartments that come with modern amenities such as private balconies and walk-in closets, providing a comfortable living experience.\n\nAt Via6, residents benefit from top-tier amenities like a state-of-the-art fitness center, a welcoming clubhouse, and a dedicated pet area. The proximity to Lake Union Park offers endless opportunities for leisure activities, whether you're into waterfront strolls or simply enjoying the scenic views. Choose Via6 as your next home to enjoy both the vibrancy of Downtown Seattle and the serene beauty of Lake Union Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown Seattle Apartments Near Lake Union Park",
      "seo_description": "Discover Via6, offering Downtown Seattle apartments near Lake Union Park. Enjoy comfort, city perks, and nearby nature. Book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-denny-park-seattle-wa",
      "search_query": "apartments near Denny Park Seattle WA",
      "category": "Park",
      "h1_title": "Apartments Near Denny Park Seattle, WA",
      "h2_subtitle": "Discover Via6's stylish apartments near Denny Park, Seattle, WA. Enjoy green spaces and urban lifestyle.",
      "page_copy": "Situated in the heart of Seattle, Via6 offers premium apartments near Denny Park, Seattle, WA. Experience the convenience of city living paired with easy access to one of Seattle's treasured green spaces. Our one- and two-bedroom apartments provide everything you need for modern living, including air conditioning and cable readiness, ensuring comfort and connectivity.\n\nAt Via6, residents have access to a host of amenities designed to support an active lifestyle, from our advanced fitness center to the engaging clubhouse. Additionally, our pet-friendly community includes a dog park, perfect for your furry friends. Living near Denny Park means you're always just a short walk away from relaxing in a lush urban oasis. Choose Via6 and embrace the perfect blend of nature and city in your daily life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denny Park, Seattle, WA - Via6",
      "seo_description": "Explore Via6's apartments near Denny Park, Seattle, WA. Enjoy urban convenience and park proximity with modern amenities. Find your ideal home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-close-to-westlake-park-seattle",
      "search_query": "apartments close to Westlake Park Seattle",
      "category": "Park",
      "h1_title": "Apartments Close to Westlake Park Seattle",
      "h2_subtitle": "Explore Via6's apartments close to Westlake Park, Seattle. Enjoy urban living with nearby vibrant city experiences.",
      "page_copy": "Located in Downtown Seattle, Via6 offers a premium living experience with apartments close to Westlake Park. Our community places you right in the heart of the city, providing easy access to vibrant shopping and dining options while offering the tranquility of nearby green spaces. Our meticulously designed one- and two-bedroom apartments feature essential amenities such as air conditioning and private balconies, ensuring you live in comfort and style.\n\nAt Via6, residents enjoy first-class amenities including a modern fitness center and a friendly clubhouse ideal for socializing or unwinding. The proximity to Westlake Park offers the perfect spot for relaxation or people-watching in a bustling urban environment. Choose Via6 for the ultimate convenience of city life mixed with accessible leisure opportunities. Experience the best of Seattle living at Via6.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Westlake Park, Seattle - Via6",
      "seo_description": "Discover Via6's apartments close to Westlake Park, Seattle. Enjoy downtown living with top amenities and cultural attractions. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "seattle-98121-apartments-near-bell-street-park",
      "search_query": "Seattle 98121 apartments near Bell Street Park",
      "category": "Park",
      "h1_title": "Seattle 98121 Apartments Near Bell Street Park",
      "h2_subtitle": "Find your home at Via6, offering Seattle 98121 apartments near Bell Street Park. Experience city living with green spaces at your doorstep.",
      "page_copy": "In the bustling heart of Seattle, Via6 presents exceptional apartment living with a location in the coveted 98121 area, just steps from Bell Street Park. These spacious one- and two-bedroom apartments are designed with comfort and convenience in mind, featuring walk-in closets, air conditioning, and private balconies, ideal for soaking in city views.\n\nVia6 isn’t just about great living spaces; it's about a vibrant community. Residents have access to amenities like a state-of-the-art fitness center and a cozy clubhouse, perfect for hosting friends. The nearby Bell Street Park offers a serene escape with its blend of urban and natural elements, perfect for relaxation or casual strolls. Choose Via6 and immerse yourself in the dynamic lifestyle of Seattle while enjoying the refreshing proximity to Bell Street Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle 98121 Apartments Near Bell Street Park - Via6",
      "seo_description": "Live at Via6, offering Seattle 98121 apartments near Bell Street Park. Experience vibrant city life with top amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-belltown-cottage-park-p-patch-seattle",
      "search_query": "apartments near Belltown Cottage Park & P-Patch Seattle",
      "category": "Park",
      "h1_title": "Apartments Near Belltown Cottage Park & P-Patch",
      "h2_subtitle": "Discover Via6, offering stylish apartments near Belltown Cottage Park & P-Patch in Seattle. Enjoy urban life with a touch of greenery.",
      "page_copy": "Experience the best of Seattle living at Via6, featuring prime apartments near Belltown Cottage Park & P-Patch. Situated in Downtown Seattle, our modern one- and two-bedroom apartments combine urban convenience with the calming presence of nearby green spaces, making it the perfect home for garden enthusiasts and city lovers alike.\n\nResidents at Via6 enjoy a host of amenities, including a welcoming clubhouse and a cutting-edge fitness center. With features like microwave ovens and air conditioning, our community ensures comfort and convenience. Located near Belltown Cottage Park & P-Patch, Via6 places you in the heart of a vibrant community, offering opportunities for gardening and relaxation just steps from your door. Embrace Seattle’s energetic lifestyle while enjoying these tranquil escapes at Via6.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belltown Cottage Park, Seattle - Via6",
      "seo_description": "Explore Via6's urban apartments near Belltown Cottage Park & P-Patch. Enjoy garden spaces and vibrant amenities in Seattle. Schedule a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "downtown-seattle-apartments-near-waterfront-park",
      "search_query": "Downtown Seattle apartments near Waterfront Park",
      "category": "Park",
      "h1_title": "Downtown Seattle Apartments Near Waterfront Park",
      "h2_subtitle": "Live at Via6, offering Downtown Seattle apartments near Waterfront Park. Enjoy stunning views and convenient city access.",
      "page_copy": "Nestled in the heart of Downtown Seattle, Via6 offers luxurious apartments close to Waterfront Park, providing an ideal blend of urban excitement and serene waterfront scenery. Our stylish one- and two-bedroom floor plans boast modern amenities such as air conditioning and private balconies, designed for comfort and city living.\n\nAt Via6, we provide our residents with unparalleled amenities like a modern fitness center and a dog park, perfect for an active lifestyle. The proximity to Waterfront Park allows you to enjoy Seattle's beautiful seaside attractions and recreational opportunities daily. Make Via6 your new home and immerse yourself in the vibrant culture and breathtaking views that Downtown Seattle offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown Seattle Apartments Near Waterfront Park - Via6",
      "seo_description": "Discover Via6's Downtown Seattle apartments near Waterfront Park. Enjoy city life with access to waterfront views and top amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-near-pioneer-square-seattle",
      "search_query": "apartments near pioneer square seattle",
      "category": "Transit",
      "h1_title": "Apartments Near Pioneer Square, Seattle",
      "h2_subtitle": "Discover Via6, offering stylish apartments near Pioneer Square, Seattle. Experience historic charm with modern comfort.",
      "page_copy": "Located in vibrant Downtown Seattle, Via6 provides residents with beautifully designed apartments just a short distance from the historic Pioneer Square. Our spacious one- and two-bedroom floor plans are perfect for those seeking a mix of modern amenities and proximity to Seattle's rich history, featuring air conditioning, walk-in closets, and private balconies.\n\nResidents of Via6 enjoy access to fantastic amenities, including a chic clubhouse and a fully-equipped fitness center. The nearby Pioneer Square area offers a plethora of boutiques, cafes, and art galleries, enriching your living experience with cultural and culinary delights. Choose Via6 for a seamless fusion of contemporary apartment living with easy access to one of Seattle’s most iconic neighborhoods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pioneer Square, Seattle - Via6",
      "seo_description": "Via6 has stylish apartments near Pioneer Square, Seattle. Enjoy modern living close to shops and history. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166934",
      "source": "generator",
      "page_item_url": "apartments-close-to-seattle-tacoma-international-airport",
      "search_query": "apartments close to seattle-tacoma international airport",
      "category": "Transit",
      "h1_title": "Apartments Close to Seattle-Tacoma International Airport",
      "h2_subtitle": "Via6 offers modern apartments conveniently located close to Seattle-Tacoma International Airport. Experience comfort and accessibility.",
      "page_copy": "Discover a blend of convenience and style at Via6, featuring apartments that offer easy access to Seattle-Tacoma International Airport. Situated in vibrant Downtown Seattle, our one- and two-bedroom apartments provide residents with modern comforts, including air conditioning and spacious walk-in closets.\n\nLiving at Via6 means enjoying premier community features such as a clubhouse for social gatherings and a state-of-the-art fitness center. With Seattle-Tacoma International Airport just a short drive away, frequent travelers will appreciate the convenience of quick airport access while residing in a bustling urban environment. Choose Via6 and enjoy the perfect combination of city excitement and logistical ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of Seattle skyline and Puget Sound.",
        "public_id": "019d01ad-a180-74dc-b4a7-4f058ec45c03",
        "storage_key": "property/6767906449166934/019d01ad-a180-74dc-b4a7-4f058ec45c03.webp",
        "width": 1800,
        "height": 700
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Seattle-Tacoma Airport - Via6",
      "seo_description": "Via6 offers modern apartments close to Seattle-Tacoma International Airport, blending city living with airport convenience. Find your home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5739"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18375040012"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2063396691"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M2N9D9FG"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Via6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "e42d163e-e0f7-4ec4-b432-c61036d3f7fe"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Via6"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "44458628388"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/27vq6ozzpox"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjRhK3c1M3U0OEhuSmdIb2trYmpQalE9PSIsInZhbHVlIjoiRzAweWQrNTRCam9GeEV5Uk9oOHVlUT09IiwibWFjIjoiZjk0NzRkOTI2ZWFkMjdhYzhkNzAyMzAxYTA3NDk1NWZkNjhkZjgyNzE5NzVjNzdlN2E5YzZjN2JhODNmMGRkMyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5739",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "18375040012",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2063396691",
  "custom_google_gtm_id": "GTM-M2N9D9FG",
  "custom_rollout_phase": "Via6",
  "custom_rentgrata_token": "e42d163e-e0f7-4ec4-b432-c61036d3f7fe",
  "custom_vibesites_theme": "Via6",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "44458628388",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/27vq6ozzpox",
  "custom_website_subscription": "custom",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjRhK3c1M3U0OEhuSmdIb2trYmpQalE9PSIsInZhbHVlIjoiRzAweWQrNTRCam9GeEV5Uk9oOHVlUT09IiwibWFjIjoiZjk0NzRkOTI2ZWFkMjdhYzhkNzAyMzAxYTA3NDk1NWZkNjhkZjgyNzE5NzVjNzdlN2E5YzZjN2JhODNmMGRkMyJ9"
};

export const generatedAt = '2026-11-03T23:28:30.882Z';
